/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.14.3.0 (NJsonSchema v10.5.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import moment from "moment";

export class ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Возвращает список АК
     * @param qualificationIds (optional) 
     * @param regionId (optional) 
     * @param searchField (optional) Поле, по которому осуществляется поиск
     * @param searchTerm (optional) Строка для поиска
     * @param page (optional) Страница, начиная с 1-й
     * @param pageSize (optional) Размер страницы, по умолчанию 10
     * @param sortOrder (optional) Направление сортировки, true - Asc, false - Desc
     * @param sortField (optional) Сортируемое поле
     * @return Success
     */
    getAttestationCommissions(qualificationIds: string[] | null | undefined, regionId: number | null | undefined, searchField: string | null | undefined, searchTerm: string | null | undefined, page: number | undefined, pageSize: number | undefined, sortOrder: boolean | null | undefined, sortField: string | null | undefined): Promise<AttestationCommissions> {
        let url_ = this.baseUrl + "/api/v1/attestation-commissions?";
        if (qualificationIds !== undefined && qualificationIds !== null)
            qualificationIds && qualificationIds.forEach(item => { url_ += "qualificationIds=" + encodeURIComponent("" + item) + "&"; });
        if (regionId !== undefined && regionId !== null)
            url_ += "regionId=" + encodeURIComponent("" + regionId) + "&";
        if (searchField !== undefined && searchField !== null)
            url_ += "searchField=" + encodeURIComponent("" + searchField) + "&";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortOrder !== undefined && sortOrder !== null)
            url_ += "sortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        if (sortField !== undefined && sortField !== null)
            url_ += "sortField=" + encodeURIComponent("" + sortField) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAttestationCommissions(_response);
        });
    }

    protected processGetAttestationCommissions(response: Response): Promise<AttestationCommissions> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AttestationCommissions.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AttestationCommissions>(<any>null);
    }

    /**
     * Возвращает информацию о АК
     * @return Success
     */
    getAttestationCommission(acId: string): Promise<AttestationCommissionDetails> {
        let url_ = this.baseUrl + "/api/v1/attestation-commissions/{acId}";
        if (acId === undefined || acId === null)
            throw new Error("The parameter 'acId' must be defined.");
        url_ = url_.replace("{acId}", encodeURIComponent("" + acId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAttestationCommission(_response);
        });
    }

    protected processGetAttestationCommission(response: Response): Promise<AttestationCommissionDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AttestationCommissionDetails.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AttestationCommissionDetails>(<any>null);
    }

    /**
     * Вход члена комиссии.
     * @param body Данные для входа.
     * @return Член комиссии успешно авторизован.
     */
    login(body: LoginExpert): Promise<AuthResult> {
        let url_ = this.baseUrl + "/api/v1/account/login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLogin(_response);
        });
    }

    protected processLogin(response: Response): Promise<AuthResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("\u0423\u043a\u0430\u0437\u0430\u043d \u043d\u0435\u0432\u0435\u0440\u043d\u044b\u0439 \u0444\u043e\u0440\u043c\u0430\u0442 \u0434\u0430\u043d\u043d\u044b\u0445.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ApiError.fromJS(resultData401);
            return throwException("\u0423\u043a\u0430\u0437\u0430\u043d \u043d\u0435\u0432\u0435\u0440\u043d\u044b\u0439 \u043b\u043e\u0433\u0438\u043d /\u043f\u0430\u0440\u043e\u043b\u044c.", status, _responseText, _headers, result401);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("\u0412\u043d\u0443\u0442\u0440\u0435\u043d\u043d\u044f\u044f \u043e\u0448\u0438\u0431\u043a\u0430 \u0441\u0435\u0440\u0432\u0435\u0440\u0430.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AuthResult>(<any>null);
    }

    /**
     * Возвращает профиль авторизованного члена комиссии
     * @return Успешно.
     */
    profile(): Promise<LinkedExpert> {
        let url_ = this.baseUrl + "/api/v1/account/profile";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProfile(_response);
        });
    }

    protected processProfile(response: Response): Promise<LinkedExpert> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LinkedExpert.fromJS(resultData200);
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("\u0412\u043d\u0443\u0442\u0440\u0435\u043d\u043d\u044f\u044f \u043e\u0448\u0438\u0431\u043a\u0430 \u0441\u0435\u0440\u0432\u0435\u0440\u0430.", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LinkedExpert>(<any>null);
    }

    /**
     * Подтверждение учетной записи, проверка токена
     * @param body (optional) 
     * @return Success
     */
    checkAccountConfirmationToken(body: CheckAccountConfirmationToken | undefined): Promise<ExpertConfirmationData> {
        let url_ = this.baseUrl + "/api/v1/account/check-confirmation-token";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCheckAccountConfirmationToken(_response);
        });
    }

    protected processCheckAccountConfirmationToken(response: Response): Promise<ExpertConfirmationData> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExpertConfirmationData.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ApiError.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExpertConfirmationData>(<any>null);
    }

    /**
     * Отправка кода верификации на телефон члена комиссии для регистрации.
     * @param body Данные для отправки кода на телефон.
     * @return OK
     */
    sendRegistrationVerificationCode(body: SendVerificationCode): Promise<VerificationCodeSendingStatus> {
        let url_ = this.baseUrl + "/api/v1/account/send-confirmation-verification-code";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSendRegistrationVerificationCode(_response);
        });
    }

    protected processSendRegistrationVerificationCode(response: Response): Promise<VerificationCodeSendingStatus> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VerificationCodeSendingStatus.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("\u0412\u043d\u0443\u0442\u0440\u0435\u043d\u043d\u044f\u044f \u043e\u0448\u0438\u0431\u043a\u0430 \u0441\u0435\u0440\u0432\u0435\u0440\u0430.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VerificationCodeSendingStatus>(<any>null);
    }

    /**
     * Проверка кода верификации аккредитуемого для регистрации.
     * @param body Данные для проверки.
     * @return Success
     */
    checkRegistrationVerificationCode(body: CheckVerificationCode): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/account/check-confirmation-verification-code";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCheckRegistrationVerificationCode(_response);
        });
    }

    protected processCheckRegistrationVerificationCode(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * Подтверждение учетной записи
     * @param body (optional) 
     * @return Success
     */
    confirmAccount(body: ConfirmAccount | undefined): Promise<AuthResult> {
        let url_ = this.baseUrl + "/api/v1/account/confirm";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processConfirmAccount(_response);
        });
    }

    protected processConfirmAccount(response: Response): Promise<AuthResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ApiError.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AuthResult>(<any>null);
    }

    /**
     * Отправка кода верификации на телефон члена комиссии для сброса пароля.
     * @param body Данные для отправки кода на телефон.
     * @return OK
     */
    sendResetPasswordVerificationCode(body: SendVerificationCode): Promise<VerificationCodeSendingStatus> {
        let url_ = this.baseUrl + "/api/v1/account/send-reset-password-verification-code";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSendResetPasswordVerificationCode(_response);
        });
    }

    protected processSendResetPasswordVerificationCode(response: Response): Promise<VerificationCodeSendingStatus> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VerificationCodeSendingStatus.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("\u0412\u043d\u0443\u0442\u0440\u0435\u043d\u043d\u044f\u044f \u043e\u0448\u0438\u0431\u043a\u0430 \u0441\u0435\u0440\u0432\u0435\u0440\u0430.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VerificationCodeSendingStatus>(<any>null);
    }

    /**
     * Проверка кода верификации члена комиссии для сброса пароля.
     * @param body Данные для проверки.
     * @return Success
     */
    checkResetPasswordVerificationCode(body: CheckVerificationCode): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/account/check-reset-password-verification-code";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCheckResetPasswordVerificationCode(_response);
        });
    }

    protected processCheckResetPasswordVerificationCode(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * Сброс пароля существующего члена комиссии.
     * @param body Данные для сброса пароля.
     * @return OK
     */
    resetPassword(body: ResetPassword): Promise<AuthResult> {
        let url_ = this.baseUrl + "/api/v1/account/reset-password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processResetPassword(_response);
        });
    }

    protected processResetPassword(response: Response): Promise<AuthResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("\u0423\u043a\u0430\u0437\u0430\u043d \u043d\u0435\u0432\u0435\u0440\u043d\u044b\u0439 \u043a\u043e\u0434 \u0432\u0435\u0440\u0438\u0444\u0438\u043a\u0430\u0446\u0438\u0438.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("\u041d\u0435 \u043d\u0430\u0439\u0434\u0435\u043d \u0430\u043a\u043a\u0440\u0435\u0434\u0438\u0442\u0443\u0435\u043c\u044b\u0439 \u0441 \u0443\u043a\u0430\u0437\u0430\u043d\u043d\u044b\u043c \u043d\u043e\u043c\u0435\u0440\u043e\u043c \u0442\u0435\u043b\u0435\u0444\u043e\u043d\u0430.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("\u0412\u043d\u0443\u0442\u0440\u0435\u043d\u043d\u044f\u044f \u043e\u0448\u0438\u0431\u043a\u0430 \u0441\u0435\u0440\u0432\u0435\u0440\u0430.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AuthResult>(<any>null);
    }

    /**
     * Отправка кода верификации на телефон члена комиссии для изменения номера.
     * @param body Данные для отправки кода на телефон.
     * @return OK
     */
    sendUpdatePhoneVerificationCode(body: SendVerificationCodeForUpdatePhone): Promise<VerificationCodeSendingStatus> {
        let url_ = this.baseUrl + "/api/v1/account/send-update-phone-verification-code";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSendUpdatePhoneVerificationCode(_response);
        });
    }

    protected processSendUpdatePhoneVerificationCode(response: Response): Promise<VerificationCodeSendingStatus> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VerificationCodeSendingStatus.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("\u0412\u043d\u0443\u0442\u0440\u0435\u043d\u043d\u044f\u044f \u043e\u0448\u0438\u0431\u043a\u0430 \u0441\u0435\u0440\u0432\u0435\u0440\u0430.", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VerificationCodeSendingStatus>(<any>null);
    }

    /**
     * Проверка кода верификации члена комиссии для изменения номера.
     * @param body Данные для проверки.
     * @return Success
     */
    checkUpdatePhoneVerificationCode(body: CheckVerificationCode): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/account/check-update-phone-verification-code";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCheckUpdatePhoneVerificationCode(_response);
        });
    }

    protected processCheckUpdatePhoneVerificationCode(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * Сохраняет изменения в профиле аккредитуемого
     * @param body (optional) 
     * @return Успешно.
     */
    updatePhone(body: UpdatePhone | undefined): Promise<Expert> {
        let url_ = this.baseUrl + "/api/v1/account/update-phone";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdatePhone(_response);
        });
    }

    protected processUpdatePhone(response: Response): Promise<Expert> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Expert.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("\u0412\u043d\u0443\u0442\u0440\u0435\u043d\u043d\u044f\u044f \u043e\u0448\u0438\u0431\u043a\u0430 \u0441\u0435\u0440\u0432\u0435\u0440\u0430.", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Expert>(<any>null);
    }

    /**
     * Возвращает состояние событий
     * @return Успешно.
     */
    getEventsState(): Promise<EventsStateHolder> {
        let url_ = this.baseUrl + "/api/v1/account/events-state";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetEventsState(_response);
        });
    }

    protected processGetEventsState(response: Response): Promise<EventsStateHolder> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EventsStateHolder.fromJS(resultData200);
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("\u0412\u043d\u0443\u0442\u0440\u0435\u043d\u043d\u044f\u044f \u043e\u0448\u0438\u0431\u043a\u0430 \u0441\u0435\u0440\u0432\u0435\u0440\u0430.", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EventsStateHolder>(<any>null);
    }

    /**
     * @return Success
     */
    getCaptcha(): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/captcha";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCaptcha(_response);
        });
    }

    protected processGetCaptcha(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Подтверждение электронной почты
     * @param body (optional) 
     * @return Success
     */
    confirmEmailByToken(body: ConfirmEmailByToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/account/confirm-email";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processConfirmEmailByToken(_response);
        });
    }

    protected processConfirmEmailByToken(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ApiError.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * Повторная отправка подтверждающего письма на почту
     * @param body (optional) 
     * @return Success
     */
    sendConfirmationEmailAgain(body: SendConfirmationEmailAgain | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/account/send-confirmation-email-again";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSendConfirmationEmailAgain(_response);
        });
    }

    protected processSendConfirmationEmailAgain(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * Смена пароля
     * @return Успешно.
     */
    changePassword(body: ChangePassword): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/account/change-password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processChangePassword(_response);
        });
    }

    protected processChangePassword(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("\u0423\u043a\u0430\u0437\u0430\u043d \u043d\u0435\u0432\u0435\u0440\u043d\u044b\u0439 \u043f\u0430\u0440\u043e\u043b\u044c.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("\u0412\u043d\u0443\u0442\u0440\u0435\u043d\u043d\u044f\u044f \u043e\u0448\u0438\u0431\u043a\u0430 \u0441\u0435\u0440\u0432\u0435\u0440\u0430.", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * Возвращает список АЦ
     * @param qualificationIds (optional) 
     * @param regionIds (optional) 
     * @param searchField (optional) Поле, по которому осуществляется поиск
     * @param searchTerm (optional) Строка для поиска
     * @param page (optional) Страница, начиная с 1-й
     * @param pageSize (optional) Размер страницы, по умолчанию 10
     * @param sortOrder (optional) Направление сортировки, true - Asc, false - Desc
     * @param sortField (optional) Сортируемое поле
     * @return Success
     */
    getAccreditationCenters(qualificationIds: string[] | null | undefined, regionIds: number[] | null | undefined, searchField: string | null | undefined, searchTerm: string | null | undefined, page: number | undefined, pageSize: number | undefined, sortOrder: boolean | null | undefined, sortField: string | null | undefined): Promise<AccreditationCenters> {
        let url_ = this.baseUrl + "/api/v1/accreditation-centers?";
        if (qualificationIds !== undefined && qualificationIds !== null)
            qualificationIds && qualificationIds.forEach(item => { url_ += "qualificationIds=" + encodeURIComponent("" + item) + "&"; });
        if (regionIds !== undefined && regionIds !== null)
            regionIds && regionIds.forEach(item => { url_ += "regionIds=" + encodeURIComponent("" + item) + "&"; });
        if (searchField !== undefined && searchField !== null)
            url_ += "searchField=" + encodeURIComponent("" + searchField) + "&";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortOrder !== undefined && sortOrder !== null)
            url_ += "sortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        if (sortField !== undefined && sortField !== null)
            url_ += "sortField=" + encodeURIComponent("" + sortField) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAccreditationCenters(_response);
        });
    }

    protected processGetAccreditationCenters(response: Response): Promise<AccreditationCenters> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AccreditationCenters.fromJS(resultData200);
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AccreditationCenters>(<any>null);
    }

    /**
     * Возвращает АПК
     * @return Успешно.
     */
    getAccreditationCenter(accreditationCenterId: string): Promise<AccreditationCenterDetails> {
        let url_ = this.baseUrl + "/api/v1/accreditation-centers/{accreditationCenterId}";
        if (accreditationCenterId === undefined || accreditationCenterId === null)
            throw new Error("The parameter 'accreditationCenterId' must be defined.");
        url_ = url_.replace("{accreditationCenterId}", encodeURIComponent("" + accreditationCenterId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAccreditationCenter(_response);
        });
    }

    protected processGetAccreditationCenter(response: Response): Promise<AccreditationCenterDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AccreditationCenterDetails.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("\u0410\u0426 \u043d\u0435 \u043d\u0430\u0439\u0434\u0435\u043d.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("\u0412\u043d\u0443\u0442\u0440\u0435\u043d\u043d\u044f\u044f \u043e\u0448\u0438\u0431\u043a\u0430 \u0441\u0435\u0440\u0432\u0435\u0440\u0430.", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AccreditationCenterDetails>(<any>null);
    }

    /**
     * Возвращает список аккредитуемых.
     * @param searchField (optional) Поле, по которому осуществляется поиск
     * @param searchTerm (optional) Строка для поиска
     * @param page (optional) Страница, начиная с 1-й
     * @param pageSize (optional) Размер страницы, по умолчанию 10
     * @param sortOrder (optional) Направление сортировки, true - Asc, false - Desc
     * @param sortField (optional) Сортируемое поле
     * @return OK
     */
    getApplicants(searchField: string | null | undefined, searchTerm: string | null | undefined, page: number | undefined, pageSize: number | undefined, sortOrder: boolean | null | undefined, sortField: string | null | undefined): Promise<Applicants> {
        let url_ = this.baseUrl + "/api/v1/applicants?";
        if (searchField !== undefined && searchField !== null)
            url_ += "searchField=" + encodeURIComponent("" + searchField) + "&";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortOrder !== undefined && sortOrder !== null)
            url_ += "sortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        if (sortField !== undefined && sortField !== null)
            url_ += "sortField=" + encodeURIComponent("" + sortField) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetApplicants(_response);
        });
    }

    protected processGetApplicants(response: Response): Promise<Applicants> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Applicants.fromJS(resultData200);
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("\u0412\u043d\u0443\u0442\u0440\u0435\u043d\u043d\u044f\u044f \u043e\u0448\u0438\u0431\u043a\u0430 \u0441\u0435\u0440\u0432\u0435\u0440\u0430", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Applicants>(<any>null);
    }

    /**
     * Возвращает аккредитуемого.
     * @return OK
     */
    getApplicant(applicantId: string): Promise<Applicant> {
        let url_ = this.baseUrl + "/api/v1/applicants/{applicantId}";
        if (applicantId === undefined || applicantId === null)
            throw new Error("The parameter 'applicantId' must be defined.");
        url_ = url_.replace("{applicantId}", encodeURIComponent("" + applicantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetApplicant(_response);
        });
    }

    protected processGetApplicant(response: Response): Promise<Applicant> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Applicant.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("\u0410\u043a\u043a\u0440\u0435\u0434\u0438\u0442\u0443\u0435\u043c\u044b\u0439 \u043d\u0435 \u043d\u0430\u0439\u0434\u0435\u043d", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("\u0412\u043d\u0443\u0442\u0440\u0435\u043d\u043d\u044f\u044f \u043e\u0448\u0438\u0431\u043a\u0430 \u0441\u0435\u0440\u0432\u0435\u0440\u0430", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Applicant>(<any>null);
    }

    /**
     * Возвращает аккредитуемого по номеру телефона.
     * @return OK
     */
    getApplicantByPhone(phone: string): Promise<Applicant> {
        let url_ = this.baseUrl + "/api/v1/applicants/by-phone/{phone}";
        if (phone === undefined || phone === null)
            throw new Error("The parameter 'phone' must be defined.");
        url_ = url_.replace("{phone}", encodeURIComponent("" + phone));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetApplicantByPhone(_response);
        });
    }

    protected processGetApplicantByPhone(response: Response): Promise<Applicant> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Applicant.fromJS(resultData200);
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("\u0412\u043d\u0443\u0442\u0440\u0435\u043d\u043d\u044f\u044f \u043e\u0448\u0438\u0431\u043a\u0430 \u0441\u0435\u0440\u0432\u0435\u0440\u0430", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return throwException("\u0410\u043a\u043a\u0440\u0435\u0434\u0438\u0442\u0443\u0435\u043c\u044b\u0439 \u043d\u0435 \u043d\u0430\u0439\u0434\u0435\u043d", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Applicant>(<any>null);
    }

    /**
     * Возвращает документ удостоверяющий личность аккредитуемого, если АК ранее подавал/принимал заявку для этого аккредитуемого
     * @return Успешно.
     */
    getIdentityDoc(applicantId: string): Promise<ApplicantIdentityDoc> {
        let url_ = this.baseUrl + "/api/v1/applicants/{applicantId}/identity-doc";
        if (applicantId === undefined || applicantId === null)
            throw new Error("The parameter 'applicantId' must be defined.");
        url_ = url_.replace("{applicantId}", encodeURIComponent("" + applicantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetIdentityDoc(_response);
        });
    }

    protected processGetIdentityDoc(response: Response): Promise<ApplicantIdentityDoc> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApplicantIdentityDoc.fromJS(resultData200);
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("\u0412\u043d\u0443\u0442\u0440\u0435\u043d\u043d\u044f\u044f \u043e\u0448\u0438\u0431\u043a\u0430 \u0441\u0435\u0440\u0432\u0435\u0440\u0430.", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("\u0410\u043a\u043a\u0440\u0435\u0434\u0438\u0442\u0443\u0435\u043c\u044b\u0439 \u043d\u0435 \u043d\u0430\u0439\u0434\u0435\u043d", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApplicantIdentityDoc>(<any>null);
    }

    /**
     * Возвращает список специальностей аккредитуемого.
     * @return OK
     */
    getApplicantQualifications(applicantId: string): Promise<ApplicantQualification[]> {
        let url_ = this.baseUrl + "/api/v1/applicants/{applicantId}/qualifications";
        if (applicantId === undefined || applicantId === null)
            throw new Error("The parameter 'applicantId' must be defined.");
        url_ = url_.replace("{applicantId}", encodeURIComponent("" + applicantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetApplicantQualifications(_response);
        });
    }

    protected processGetApplicantQualifications(response: Response): Promise<ApplicantQualification[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApplicantQualification.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("\u0412\u043d\u0443\u0442\u0440\u0435\u043d\u043d\u044f\u044f \u043e\u0448\u0438\u0431\u043a\u0430 \u0441\u0435\u0440\u0432\u0435\u0440\u0430", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApplicantQualification[]>(<any>null);
    }

    /**
     * Возвращает детали специальностей аккредитуемого.
     * @return OK
     */
    getApplicantQualificationDetails(applicantId: string, examApplicationId: string): Promise<ApplicantQualificationDetails> {
        let url_ = this.baseUrl + "/api/v1/applicants/{applicantId}/qualifications/{examApplicationId}";
        if (applicantId === undefined || applicantId === null)
            throw new Error("The parameter 'applicantId' must be defined.");
        url_ = url_.replace("{applicantId}", encodeURIComponent("" + applicantId));
        if (examApplicationId === undefined || examApplicationId === null)
            throw new Error("The parameter 'examApplicationId' must be defined.");
        url_ = url_.replace("{examApplicationId}", encodeURIComponent("" + examApplicationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetApplicantQualificationDetails(_response);
        });
    }

    protected processGetApplicantQualificationDetails(response: Response): Promise<ApplicantQualificationDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApplicantQualificationDetails.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("\u0412\u043d\u0443\u0442\u0440\u0435\u043d\u043d\u044f\u044f \u043e\u0448\u0438\u0431\u043a\u0430 \u0441\u0435\u0440\u0432\u0435\u0440\u0430", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApplicantQualificationDetails>(<any>null);
    }

    /**
     * Возвращает список аккредитаций аккредитуемого.
     * @param searchField (optional) Поле, по которому осуществляется поиск
     * @param searchTerm (optional) Строка для поиска
     * @param page (optional) Страница, начиная с 1-й
     * @param pageSize (optional) Размер страницы, по умолчанию 10
     * @param sortOrder (optional) Направление сортировки, true - Asc, false - Desc
     * @param sortField (optional) Сортируемое поле
     * @return OK
     */
    getApplicantArchiveExams(applicantId: string, searchField: string | null | undefined, searchTerm: string | null | undefined, page: number | undefined, pageSize: number | undefined, sortOrder: boolean | null | undefined, sortField: string | null | undefined): Promise<ApplicantExamList> {
        let url_ = this.baseUrl + "/api/v1/applicants/{applicantId}/archive-exams?";
        if (applicantId === undefined || applicantId === null)
            throw new Error("The parameter 'applicantId' must be defined.");
        url_ = url_.replace("{applicantId}", encodeURIComponent("" + applicantId));
        if (searchField !== undefined && searchField !== null)
            url_ += "searchField=" + encodeURIComponent("" + searchField) + "&";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortOrder !== undefined && sortOrder !== null)
            url_ += "sortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        if (sortField !== undefined && sortField !== null)
            url_ += "sortField=" + encodeURIComponent("" + sortField) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetApplicantArchiveExams(_response);
        });
    }

    protected processGetApplicantArchiveExams(response: Response): Promise<ApplicantExamList> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApplicantExamList.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("\u0412\u043d\u0443\u0442\u0440\u0435\u043d\u043d\u044f\u044f \u043e\u0448\u0438\u0431\u043a\u0430 \u0441\u0435\u0440\u0432\u0435\u0440\u0430", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApplicantExamList>(<any>null);
    }

    /**
     * Возвращает список АПК
     * @param acIds (optional) 
     * @param regionIds (optional) 
     * @param searchField (optional) Поле, по которому осуществляется поиск
     * @param searchTerm (optional) Строка для поиска
     * @param page (optional) Страница, начиная с 1-й
     * @param pageSize (optional) Размер страницы, по умолчанию 10
     * @param sortOrder (optional) Направление сортировки, true - Asc, false - Desc
     * @param sortField (optional) Сортируемое поле
     * @return Success
     */
    getAttestationSubCommissions(acIds: string[] | null | undefined, regionIds: number[] | null | undefined, searchField: string | null | undefined, searchTerm: string | null | undefined, page: number | undefined, pageSize: number | undefined, sortOrder: boolean | null | undefined, sortField: string | null | undefined): Promise<AttestationSubCommissionsList> {
        let url_ = this.baseUrl + "/api/v1/attestation-sub-commissions?";
        if (acIds !== undefined && acIds !== null)
            acIds && acIds.forEach(item => { url_ += "acIds=" + encodeURIComponent("" + item) + "&"; });
        if (regionIds !== undefined && regionIds !== null)
            regionIds && regionIds.forEach(item => { url_ += "regionIds=" + encodeURIComponent("" + item) + "&"; });
        if (searchField !== undefined && searchField !== null)
            url_ += "searchField=" + encodeURIComponent("" + searchField) + "&";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortOrder !== undefined && sortOrder !== null)
            url_ += "sortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        if (sortField !== undefined && sortField !== null)
            url_ += "sortField=" + encodeURIComponent("" + sortField) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAttestationSubCommissions(_response);
        });
    }

    protected processGetAttestationSubCommissions(response: Response): Promise<AttestationSubCommissionsList> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AttestationSubCommissionsList.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AttestationSubCommissionsList>(<any>null);
    }

    /**
     * Возвращает АПК
     * @return Успешно.
     */
    getAttestationSubCommission(attestationSubCommissionId: string): Promise<AttestationSubCommissionDetails> {
        let url_ = this.baseUrl + "/api/v1/attestation-sub-commissions/{attestationSubCommissionId}";
        if (attestationSubCommissionId === undefined || attestationSubCommissionId === null)
            throw new Error("The parameter 'attestationSubCommissionId' must be defined.");
        url_ = url_.replace("{attestationSubCommissionId}", encodeURIComponent("" + attestationSubCommissionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAttestationSubCommission(_response);
        });
    }

    protected processGetAttestationSubCommission(response: Response): Promise<AttestationSubCommissionDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AttestationSubCommissionDetails.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("\u0410\u041f\u041a \u043d\u0435 \u043d\u0430\u0439\u0434\u0435\u043d.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("\u0412\u043d\u0443\u0442\u0440\u0435\u043d\u043d\u044f\u044f \u043e\u0448\u0438\u0431\u043a\u0430 \u0441\u0435\u0440\u0432\u0435\u0440\u0430.", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AttestationSubCommissionDetails>(<any>null);
    }

    /**
     * Возвращает список свидетельств члена комиссии
     * @return Успешно.
     */
    getExpertCertificates(): Promise<ExpertCertificate[]> {
        let url_ = this.baseUrl + "/api/v1/certificates";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetExpertCertificates(_response);
        });
    }

    protected processGetExpertCertificates(response: Response): Promise<ExpertCertificate[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ExpertCertificate.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("\u0412\u043d\u0443\u0442\u0440\u0435\u043d\u043d\u044f\u044f \u043e\u0448\u0438\u0431\u043a\u0430 \u0441\u0435\u0440\u0432\u0435\u0440\u0430.", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExpertCertificate[]>(<any>null);
    }

    /**
     * Добавляет свидетельство члена комиссии
     * @param regNumber (optional) 
     * @param issueDate (optional) 
     * @param expireDate (optional) 
     * @param contentType (optional) 
     * @param contentDisposition (optional) 
     * @param headers (optional) 
     * @param length (optional) 
     * @param name (optional) 
     * @param fileName (optional) 
     * @return Успешно.
     */
    addExpertCertificate(regNumber: string | undefined, issueDate: moment.Moment | undefined, expireDate: moment.Moment | undefined, contentType: string | undefined, contentDisposition: string | undefined, headers: { [key: string]: string[]; } | undefined, length: number | undefined, name: string | undefined, fileName: string | undefined): Promise<ExpertCertificate[]> {
        let url_ = this.baseUrl + "/api/v1/certificates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (regNumber === null || regNumber === undefined)
            throw new Error("The parameter 'regNumber' cannot be null.");
        else
            content_.append("regNumber", regNumber.toString());
        if (issueDate === null || issueDate === undefined)
            throw new Error("The parameter 'issueDate' cannot be null.");
        else
            content_.append("issueDate", issueDate.toJSON());
        if (expireDate === null || expireDate === undefined)
            throw new Error("The parameter 'expireDate' cannot be null.");
        else
            content_.append("expireDate", expireDate.toJSON());
        if (contentType === null || contentType === undefined)
            throw new Error("The parameter 'contentType' cannot be null.");
        else
            content_.append("contentType", contentType.toString());
        if (contentDisposition === null || contentDisposition === undefined)
            throw new Error("The parameter 'contentDisposition' cannot be null.");
        else
            content_.append("contentDisposition", contentDisposition.toString());
        if (headers === null || headers === undefined)
            throw new Error("The parameter 'headers' cannot be null.");
        else
            content_.append("headers", JSON.stringify(headers));
        if (length === null || length === undefined)
            throw new Error("The parameter 'length' cannot be null.");
        else
            content_.append("length", length.toString());
        if (name === null || name === undefined)
            throw new Error("The parameter 'name' cannot be null.");
        else
            content_.append("name", name.toString());
        if (fileName === null || fileName === undefined)
            throw new Error("The parameter 'fileName' cannot be null.");
        else
            content_.append("fileName", fileName.toString());

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddExpertCertificate(_response);
        });
    }

    protected processAddExpertCertificate(response: Response): Promise<ExpertCertificate[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ExpertCertificate.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("\u0412\u043d\u0443\u0442\u0440\u0435\u043d\u043d\u044f\u044f \u043e\u0448\u0438\u0431\u043a\u0430 \u0441\u0435\u0440\u0432\u0435\u0440\u0430.", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExpertCertificate[]>(<any>null);
    }

    /**
     * Возвращает свидетельство члена комиссии
     * @return Успешно.
     */
    getExpertCertificate(certificateId: string): Promise<ExpertCertificate> {
        let url_ = this.baseUrl + "/api/v1/certificates/{certificateId}";
        if (certificateId === undefined || certificateId === null)
            throw new Error("The parameter 'certificateId' must be defined.");
        url_ = url_.replace("{certificateId}", encodeURIComponent("" + certificateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetExpertCertificate(_response);
        });
    }

    protected processGetExpertCertificate(response: Response): Promise<ExpertCertificate> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExpertCertificate.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("\u0412\u043d\u0443\u0442\u0440\u0435\u043d\u043d\u044f\u044f \u043e\u0448\u0438\u0431\u043a\u0430 \u0441\u0435\u0440\u0432\u0435\u0440\u0430.", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExpertCertificate>(<any>null);
    }

    /**
     * Обновляет свидетельство члена комиссии
     * @param contentType (optional) 
     * @param contentDisposition (optional) 
     * @param headers (optional) 
     * @param length (optional) 
     * @param name (optional) 
     * @param fileName (optional) 
     * @param regNumber (optional) 
     * @param issueDate (optional) 
     * @param expireDate (optional) 
     * @return Успешно.
     */
    updateExpertCertificate(certificateId: string, contentType: string | undefined, contentDisposition: string | undefined, headers: { [key: string]: string[]; } | undefined, length: number | undefined, name: string | undefined, fileName: string | undefined, regNumber: string | undefined, issueDate: moment.Moment | undefined, expireDate: moment.Moment | undefined): Promise<ExpertCertificate[]> {
        let url_ = this.baseUrl + "/api/v1/certificates/{certificateId}";
        if (certificateId === undefined || certificateId === null)
            throw new Error("The parameter 'certificateId' must be defined.");
        url_ = url_.replace("{certificateId}", encodeURIComponent("" + certificateId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (contentType === null || contentType === undefined)
            throw new Error("The parameter 'contentType' cannot be null.");
        else
            content_.append("contentType", contentType.toString());
        if (contentDisposition === null || contentDisposition === undefined)
            throw new Error("The parameter 'contentDisposition' cannot be null.");
        else
            content_.append("contentDisposition", contentDisposition.toString());
        if (headers === null || headers === undefined)
            throw new Error("The parameter 'headers' cannot be null.");
        else
            content_.append("headers", JSON.stringify(headers));
        if (length === null || length === undefined)
            throw new Error("The parameter 'length' cannot be null.");
        else
            content_.append("length", length.toString());
        if (name === null || name === undefined)
            throw new Error("The parameter 'name' cannot be null.");
        else
            content_.append("name", name.toString());
        if (fileName === null || fileName === undefined)
            throw new Error("The parameter 'fileName' cannot be null.");
        else
            content_.append("fileName", fileName.toString());
        if (regNumber === null || regNumber === undefined)
            throw new Error("The parameter 'regNumber' cannot be null.");
        else
            content_.append("regNumber", regNumber.toString());
        if (issueDate === null || issueDate === undefined)
            throw new Error("The parameter 'issueDate' cannot be null.");
        else
            content_.append("issueDate", issueDate.toJSON());
        if (expireDate === null || expireDate === undefined)
            throw new Error("The parameter 'expireDate' cannot be null.");
        else
            content_.append("expireDate", expireDate.toJSON());

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateExpertCertificate(_response);
        });
    }

    protected processUpdateExpertCertificate(response: Response): Promise<ExpertCertificate[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ExpertCertificate.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("\u0412\u043d\u0443\u0442\u0440\u0435\u043d\u043d\u044f\u044f \u043e\u0448\u0438\u0431\u043a\u0430 \u0441\u0435\u0440\u0432\u0435\u0440\u0430.", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExpertCertificate[]>(<any>null);
    }

    /**
     * Удаляет свидетельство члена комиссии
     * @return Успешно.
     */
    removeExpertCertificate(certificateId: string): Promise<ExpertCertificate[]> {
        let url_ = this.baseUrl + "/api/v1/certificates/{certificateId}";
        if (certificateId === undefined || certificateId === null)
            throw new Error("The parameter 'certificateId' must be defined.");
        url_ = url_.replace("{certificateId}", encodeURIComponent("" + certificateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRemoveExpertCertificate(_response);
        });
    }

    protected processRemoveExpertCertificate(response: Response): Promise<ExpertCertificate[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ExpertCertificate.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("\u0412\u043d\u0443\u0442\u0440\u0435\u043d\u043d\u044f\u044f \u043e\u0448\u0438\u0431\u043a\u0430 \u0441\u0435\u0440\u0432\u0435\u0440\u0430.", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExpertCertificate[]>(<any>null);
    }

    /**
     * Возвращает список заявок на аккредитации.
     * @param examId (optional) 
     * @param searchField (optional) Поле, по которому осуществляется поиск
     * @param searchTerm (optional) Строка для поиска
     * @param page (optional) Страница, начиная с 1-й
     * @param pageSize (optional) Размер страницы, по умолчанию 10
     * @param sortOrder (optional) Направление сортировки, true - Asc, false - Desc
     * @param sortField (optional) Сортируемое поле
     * @return Пользователь успешно авторизован.
     */
    getExamApplications(examId: string | null | undefined, searchField: string | null | undefined, searchTerm: string | null | undefined, page: number | undefined, pageSize: number | undefined, sortOrder: boolean | null | undefined, sortField: string | null | undefined): Promise<ExamApplicationList> {
        let url_ = this.baseUrl + "/api/v1/exam-applications?";
        if (examId !== undefined && examId !== null)
            url_ += "examId=" + encodeURIComponent("" + examId) + "&";
        if (searchField !== undefined && searchField !== null)
            url_ += "searchField=" + encodeURIComponent("" + searchField) + "&";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortOrder !== undefined && sortOrder !== null)
            url_ += "sortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        if (sortField !== undefined && sortField !== null)
            url_ += "sortField=" + encodeURIComponent("" + sortField) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetExamApplications(_response);
        });
    }

    protected processGetExamApplications(response: Response): Promise<ExamApplicationList> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExamApplicationList.fromJS(resultData200);
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("\u0412\u043d\u0443\u0442\u0440\u0435\u043d\u043d\u044f\u044f \u043e\u0448\u0438\u0431\u043a\u0430 \u0441\u0435\u0440\u0432\u0435\u0440\u0430.", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExamApplicationList>(<any>null);
    }

    /**
     * Возвращает список заявок на аккредитации для финализации результата.
     * @param examId (optional) 
     * @param searchField (optional) Поле, по которому осуществляется поиск
     * @param searchTerm (optional) Строка для поиска
     * @param page (optional) Страница, начиная с 1-й
     * @param pageSize (optional) Размер страницы, по умолчанию 10
     * @param sortOrder (optional) Направление сортировки, true - Asc, false - Desc
     * @param sortField (optional) Сортируемое поле
     * @return Пользователь успешно авторизован.
     */
    getExamApplicationsForFinalize(examId: string | null | undefined, searchField: string | null | undefined, searchTerm: string | null | undefined, page: number | undefined, pageSize: number | undefined, sortOrder: boolean | null | undefined, sortField: string | null | undefined): Promise<ExamApplicationList> {
        let url_ = this.baseUrl + "/api/v1/exam-applications/finalizing?";
        if (examId !== undefined && examId !== null)
            url_ += "examId=" + encodeURIComponent("" + examId) + "&";
        if (searchField !== undefined && searchField !== null)
            url_ += "searchField=" + encodeURIComponent("" + searchField) + "&";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortOrder !== undefined && sortOrder !== null)
            url_ += "sortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        if (sortField !== undefined && sortField !== null)
            url_ += "sortField=" + encodeURIComponent("" + sortField) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetExamApplicationsForFinalize(_response);
        });
    }

    protected processGetExamApplicationsForFinalize(response: Response): Promise<ExamApplicationList> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExamApplicationList.fromJS(resultData200);
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("\u0412\u043d\u0443\u0442\u0440\u0435\u043d\u043d\u044f\u044f \u043e\u0448\u0438\u0431\u043a\u0430 \u0441\u0435\u0440\u0432\u0435\u0440\u0430.", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExamApplicationList>(<any>null);
    }

    /**
     * Возвращает заявку аккредитуемого
     * @return Успешно.
     */
    getExamApplication(examApplicationId: string): Promise<ExamApplicationDetails> {
        let url_ = this.baseUrl + "/api/v1/exam-applications/{examApplicationId}";
        if (examApplicationId === undefined || examApplicationId === null)
            throw new Error("The parameter 'examApplicationId' must be defined.");
        url_ = url_.replace("{examApplicationId}", encodeURIComponent("" + examApplicationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetExamApplication(_response);
        });
    }

    protected processGetExamApplication(response: Response): Promise<ExamApplicationDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExamApplicationDetails.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("\u0412\u043d\u0443\u0442\u0440\u0435\u043d\u043d\u044f\u044f \u043e\u0448\u0438\u0431\u043a\u0430 \u0441\u0435\u0440\u0432\u0435\u0440\u0430.", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExamApplicationDetails>(<any>null);
    }

    /**
     * Возвращает список неоцененных заявок на аккредитацию
     * @param page (optional) Страница, начиная с 1-й
     * @param pageSize (optional) Размер страницы, по умолчанию 10
     * @param sortOrder (optional) Направление сортировки, true - Asc, false - Desc
     * @param sortField (optional) Сортируемое поле
     * @return Success
     */
    getUnratedExamApplications(examDayId: string, page: number | undefined, pageSize: number | undefined, sortOrder: boolean | null | undefined, sortField: string | null | undefined): Promise<ExamApplicationList> {
        let url_ = this.baseUrl + "/api/v1/exam-applications/unrated-for-day/{examDayId}?";
        if (examDayId === undefined || examDayId === null)
            throw new Error("The parameter 'examDayId' must be defined.");
        url_ = url_.replace("{examDayId}", encodeURIComponent("" + examDayId));
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortOrder !== undefined && sortOrder !== null)
            url_ += "sortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        if (sortField !== undefined && sortField !== null)
            url_ += "sortField=" + encodeURIComponent("" + sortField) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUnratedExamApplications(_response);
        });
    }

    protected processGetUnratedExamApplications(response: Response): Promise<ExamApplicationList> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExamApplicationList.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExamApplicationList>(<any>null);
    }

    /**
     * Получение списка аккредитаций в процессе обработки
     * @return Success
     */
    getExamsInProcessing(): Promise<Exam[]> {
        let url_ = this.baseUrl + "/api/v1/exams/in-processing";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetExamsInProcessing(_response);
        });
    }

    protected processGetExamsInProcessing(response: Response): Promise<Exam[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Exam.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Exam[]>(<any>null);
    }

    /**
     * Получение списка аккредитаций для одобрения
     * @param page (optional) Страница, начиная с 1-й
     * @param pageSize (optional) Размер страницы, по умолчанию 10
     * @param sortOrder (optional) Направление сортировки, true - Asc, false - Desc
     * @param sortField (optional) Сортируемое поле
     * @return Success
     */
    getWaitingForApprovalExams(page: number | undefined, pageSize: number | undefined, sortOrder: boolean | null | undefined, sortField: string | null | undefined): Promise<ExamList> {
        let url_ = this.baseUrl + "/api/v1/exams/waiting-for-approval?";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortOrder !== undefined && sortOrder !== null)
            url_ += "sortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        if (sortField !== undefined && sortField !== null)
            url_ += "sortField=" + encodeURIComponent("" + sortField) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetWaitingForApprovalExams(_response);
        });
    }

    protected processGetWaitingForApprovalExams(response: Response): Promise<ExamList> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExamList.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("\u0412\u043d\u0443\u0442\u0440\u0435\u043d\u043d\u044f\u044f \u043e\u0448\u0438\u0431\u043a\u0430 \u0441\u0435\u0440\u0432\u0435\u0440\u0430.", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExamList>(<any>null);
    }

    /**
     * Отправить код для одобрения АМ
     * @return Success
     */
    sendCodeForApproveExam(examId: string, body: SendCodeForApproveExam): Promise<VerificationCodeSendingStatus> {
        let url_ = this.baseUrl + "/api/v1/exams/{examId}/send-code-for-approve";
        if (examId === undefined || examId === null)
            throw new Error("The parameter 'examId' must be defined.");
        url_ = url_.replace("{examId}", encodeURIComponent("" + examId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSendCodeForApproveExam(_response);
        });
    }

    protected processSendCodeForApproveExam(response: Response): Promise<VerificationCodeSendingStatus> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VerificationCodeSendingStatus.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VerificationCodeSendingStatus>(<any>null);
    }

    /**
     * Одобрить АМ
     * @param examId ид аккредитации
     * @return Success
     */
    approveExam(examId: string, body: ApproveExam): Promise<ExamDetails> {
        let url_ = this.baseUrl + "/api/v1/exams/{examId}/approve";
        if (examId === undefined || examId === null)
            throw new Error("The parameter 'examId' must be defined.");
        url_ = url_.replace("{examId}", encodeURIComponent("" + examId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApproveExam(_response);
        });
    }

    protected processApproveExam(response: Response): Promise<ExamDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExamDetails.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExamDetails>(<any>null);
    }

    /**
     * Фильтр всех аккредитаций члена комиссии
     * @param qualificationIds (optional) 
     * @param attestationSubCommissionIds (optional) 
     * @param accreditationCenterIds (optional) 
     * @param filteredExamStatus (optional) 
     * @param from (optional) Дата аккредитации, с
     * @param to (optional) Дата аккредитации, по
     * @param page (optional) Страница, начиная с 1-й
     * @param pageSize (optional) Размер страницы, по умолчанию 10
     * @param sortOrder (optional) Направление сортировки, true - Asc, false - Desc
     * @param sortField (optional) Сортируемое поле
     * @return Success
     */
    getExamFilteredList(qualificationIds: string[] | null | undefined, attestationSubCommissionIds: string[] | null | undefined, accreditationCenterIds: string[] | null | undefined, filteredExamStatus: FilteredExamStatus | undefined, from: moment.Moment | null | undefined, to: moment.Moment | null | undefined, page: number | undefined, pageSize: number | undefined, sortOrder: boolean | null | undefined, sortField: string | null | undefined): Promise<ExamList> {
        let url_ = this.baseUrl + "/api/v1/exams/filter?";
        if (qualificationIds !== undefined && qualificationIds !== null)
            qualificationIds && qualificationIds.forEach(item => { url_ += "qualificationIds=" + encodeURIComponent("" + item) + "&"; });
        if (attestationSubCommissionIds !== undefined && attestationSubCommissionIds !== null)
            attestationSubCommissionIds && attestationSubCommissionIds.forEach(item => { url_ += "attestationSubCommissionIds=" + encodeURIComponent("" + item) + "&"; });
        if (accreditationCenterIds !== undefined && accreditationCenterIds !== null)
            accreditationCenterIds && accreditationCenterIds.forEach(item => { url_ += "accreditationCenterIds=" + encodeURIComponent("" + item) + "&"; });
        if (filteredExamStatus === null)
            throw new Error("The parameter 'filteredExamStatus' cannot be null.");
        else if (filteredExamStatus !== undefined)
            url_ += "filteredExamStatus=" + encodeURIComponent("" + filteredExamStatus) + "&";
        if (from !== undefined && from !== null)
            url_ += "from=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to !== undefined && to !== null)
            url_ += "to=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortOrder !== undefined && sortOrder !== null)
            url_ += "sortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        if (sortField !== undefined && sortField !== null)
            url_ += "sortField=" + encodeURIComponent("" + sortField) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetExamFilteredList(_response);
        });
    }

    protected processGetExamFilteredList(response: Response): Promise<ExamList> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExamList.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExamList>(<any>null);
    }

    /**
     * Получение списка идентификаторов аккредитаций нуждающихся во внимании члена комиссии
     * @return Success
     */
    getNeedingAttentionExamIds(): Promise<string[]> {
        let url_ = this.baseUrl + "/api/v1/exams/needing-attention";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetNeedingAttentionExamIds(_response);
        });
    }

    protected processGetNeedingAttentionExamIds(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(<any>null);
    }

    /**
     * Получение информации по аккредитации
     * @param examId id аккредитации
     * @return Success
     */
    getExam(examId: string): Promise<ExamDetails> {
        let url_ = this.baseUrl + "/api/v1/exams/{examId}";
        if (examId === undefined || examId === null)
            throw new Error("The parameter 'examId' must be defined.");
        url_ = url_.replace("{examId}", encodeURIComponent("" + examId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetExam(_response);
        });
    }

    protected processGetExam(response: Response): Promise<ExamDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExamDetails.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExamDetails>(<any>null);
    }

    /**
     * Возвращает список нераспределенных заявок на аккредитацию
     * @param page (optional) Страница, начиная с 1-й
     * @param pageSize (optional) Размер страницы, по умолчанию 10
     * @param sortOrder (optional) Направление сортировки, true - Asc, false - Desc
     * @param sortField (optional) Сортируемое поле
     * @return Success
     */
    getUnassignedExamApplicationsForStage(examId: string, stage: number, page: number | undefined, pageSize: number | undefined, sortOrder: boolean | null | undefined, sortField: string | null | undefined): Promise<ExamApplicationList> {
        let url_ = this.baseUrl + "/api/v1/exams/{examId}/stage/{stage}/unassigned-exam-applications?";
        if (examId === undefined || examId === null)
            throw new Error("The parameter 'examId' must be defined.");
        url_ = url_.replace("{examId}", encodeURIComponent("" + examId));
        if (stage === undefined || stage === null)
            throw new Error("The parameter 'stage' must be defined.");
        url_ = url_.replace("{stage}", encodeURIComponent("" + stage));
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortOrder !== undefined && sortOrder !== null)
            url_ += "sortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        if (sortField !== undefined && sortField !== null)
            url_ += "sortField=" + encodeURIComponent("" + sortField) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUnassignedExamApplicationsForStage(_response);
        });
    }

    protected processGetUnassignedExamApplicationsForStage(response: Response): Promise<ExamApplicationList> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExamApplicationList.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExamApplicationList>(<any>null);
    }

    /**
     * Возвращает список распределенных заявок на АД
     * @param page (optional) Страница, начиная с 1-й
     * @param pageSize (optional) Размер страницы, по умолчанию 10
     * @param sortOrder (optional) Направление сортировки, true - Asc, false - Desc
     * @param sortField (optional) Сортируемое поле
     * @return Success
     */
    getExamDayApplications(examId: string, stage: number, examDayId: string, page: number | undefined, pageSize: number | undefined, sortOrder: boolean | null | undefined, sortField: string | null | undefined): Promise<ExamDayApplications> {
        let url_ = this.baseUrl + "/api/v1/exams/{examId}/stage/{stage}/day/{examDayId}/exam-day-applications?";
        if (examId === undefined || examId === null)
            throw new Error("The parameter 'examId' must be defined.");
        url_ = url_.replace("{examId}", encodeURIComponent("" + examId));
        if (stage === undefined || stage === null)
            throw new Error("The parameter 'stage' must be defined.");
        url_ = url_.replace("{stage}", encodeURIComponent("" + stage));
        if (examDayId === undefined || examDayId === null)
            throw new Error("The parameter 'examDayId' must be defined.");
        url_ = url_.replace("{examDayId}", encodeURIComponent("" + examDayId));
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortOrder !== undefined && sortOrder !== null)
            url_ += "sortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        if (sortField !== undefined && sortField !== null)
            url_ += "sortField=" + encodeURIComponent("" + sortField) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetExamDayApplications(_response);
        });
    }

    protected processGetExamDayApplications(response: Response): Promise<ExamDayApplications> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExamDayApplications.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExamDayApplications>(<any>null);
    }

    /**
     * Получение списка запросов на формирование членов АПК
     * @param expertIds (optional) 
     * @param from (optional) 
     * @param to (optional) 
     * @param status (optional) 
     * @param type (optional) 
     * @param page (optional) Страница, начиная с 1-й
     * @param pageSize (optional) Размер страницы, по умолчанию 10
     * @param sortOrder (optional) Направление сортировки, true - Asc, false - Desc
     * @param sortField (optional) Сортируемое поле
     * @return Success
     */
    getCurrentExpertChangeRequests(expertIds: string[] | null | undefined, from: moment.Moment | null | undefined, to: moment.Moment | null | undefined, status: ExpertChangeRequestStatus | undefined, type: ExpertChangeRequestsOrderType | undefined, page: number | undefined, pageSize: number | undefined, sortOrder: boolean | null | undefined, sortField: string | null | undefined): Promise<ExpertChangeRequests> {
        let url_ = this.baseUrl + "/api/v1/expert-change-requests?";
        if (expertIds !== undefined && expertIds !== null)
            expertIds && expertIds.forEach(item => { url_ += "expertIds=" + encodeURIComponent("" + item) + "&"; });
        if (from !== undefined && from !== null)
            url_ += "from=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to !== undefined && to !== null)
            url_ += "to=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortOrder !== undefined && sortOrder !== null)
            url_ += "sortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        if (sortField !== undefined && sortField !== null)
            url_ += "sortField=" + encodeURIComponent("" + sortField) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCurrentExpertChangeRequests(_response);
        });
    }

    protected processGetCurrentExpertChangeRequests(response: Response): Promise<ExpertChangeRequests> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExpertChangeRequests.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("\u0412\u043d\u0443\u0442\u0440\u0435\u043d\u043d\u044f\u044f \u043e\u0448\u0438\u0431\u043a\u0430 \u0441\u0435\u0440\u0432\u0435\u0440\u0430.", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExpertChangeRequests>(<any>null);
    }

    /**
     * Получение списка истории запросов на формирование членов АПК
     * @param expertId (optional) 
     * @param from (optional) 
     * @param to (optional) 
     * @param page (optional) Страница, начиная с 1-й
     * @param pageSize (optional) Размер страницы, по умолчанию 10
     * @param sortOrder (optional) Направление сортировки, true - Asc, false - Desc
     * @param sortField (optional) Сортируемое поле
     * @return Success
     */
    getExpertChangeRequestsHistory(expertId: string | null | undefined, from: moment.Moment | null | undefined, to: moment.Moment | null | undefined, page: number | undefined, pageSize: number | undefined, sortOrder: boolean | null | undefined, sortField: string | null | undefined): Promise<ExpertChangeRequests> {
        let url_ = this.baseUrl + "/api/v1/expert-change-requests/history?";
        if (expertId !== undefined && expertId !== null)
            url_ += "expertId=" + encodeURIComponent("" + expertId) + "&";
        if (from !== undefined && from !== null)
            url_ += "from=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to !== undefined && to !== null)
            url_ += "to=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortOrder !== undefined && sortOrder !== null)
            url_ += "sortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        if (sortField !== undefined && sortField !== null)
            url_ += "sortField=" + encodeURIComponent("" + sortField) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetExpertChangeRequestsHistory(_response);
        });
    }

    protected processGetExpertChangeRequestsHistory(response: Response): Promise<ExpertChangeRequests> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExpertChangeRequests.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("\u0412\u043d\u0443\u0442\u0440\u0435\u043d\u043d\u044f\u044f \u043e\u0448\u0438\u0431\u043a\u0430 \u0441\u0435\u0440\u0432\u0435\u0440\u0430.", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExpertChangeRequests>(<any>null);
    }

    /**
     * Возвращает запрос на формирование членов АПК
     * @return Успешно.
     */
    getExpertChangeRequest(expertChangeRequestId: string): Promise<ExpertChangeRequestDetails> {
        let url_ = this.baseUrl + "/api/v1/expert-change-requests/{expertChangeRequestId}";
        if (expertChangeRequestId === undefined || expertChangeRequestId === null)
            throw new Error("The parameter 'expertChangeRequestId' must be defined.");
        url_ = url_.replace("{expertChangeRequestId}", encodeURIComponent("" + expertChangeRequestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetExpertChangeRequest(_response);
        });
    }

    protected processGetExpertChangeRequest(response: Response): Promise<ExpertChangeRequestDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExpertChangeRequestDetails.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("\u0412\u043d\u0443\u0442\u0440\u0435\u043d\u043d\u044f\u044f \u043e\u0448\u0438\u0431\u043a\u0430 \u0441\u0435\u0440\u0432\u0435\u0440\u0430.", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExpertChangeRequestDetails>(<any>null);
    }

    /**
     * Отправить код для одобрения запроса на изменение
     * @return Success
     */
    sendCodeForApproveExpertChangeRequest(expertChangeRequestId: string, body: SendCodeForApproveExpertChangeRequest): Promise<VerificationCodeSendingStatus> {
        let url_ = this.baseUrl + "/api/v1/expert-change-requests/{expertChangeRequestId}/send-code-for-approve";
        if (expertChangeRequestId === undefined || expertChangeRequestId === null)
            throw new Error("The parameter 'expertChangeRequestId' must be defined.");
        url_ = url_.replace("{expertChangeRequestId}", encodeURIComponent("" + expertChangeRequestId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSendCodeForApproveExpertChangeRequest(_response);
        });
    }

    protected processSendCodeForApproveExpertChangeRequest(response: Response): Promise<VerificationCodeSendingStatus> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VerificationCodeSendingStatus.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VerificationCodeSendingStatus>(<any>null);
    }

    /**
     * Одобрить запроса на изменение
     * @param expertChangeRequestId ид запроса
     * @return Success
     */
    approveExpertChangeRequest(expertChangeRequestId: string, body: ApproveExpertChangeRequest): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/expert-change-requests/{expertChangeRequestId}/approve";
        if (expertChangeRequestId === undefined || expertChangeRequestId === null)
            throw new Error("The parameter 'expertChangeRequestId' must be defined.");
        url_ = url_.replace("{expertChangeRequestId}", encodeURIComponent("" + expertChangeRequestId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApproveExpertChangeRequest(_response);
        });
    }

    protected processApproveExpertChangeRequest(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * Отклонить запроса на изменение
     * @param expertChangeRequestId ид запроса
     * @return Success
     */
    rejectExpertChangeRequest(expertChangeRequestId: string, body: RejectExpertChangeRequest): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/expert-change-requests/{expertChangeRequestId}/reject";
        if (expertChangeRequestId === undefined || expertChangeRequestId === null)
            throw new Error("The parameter 'expertChangeRequestId' must be defined.");
        url_ = url_.replace("{expertChangeRequestId}", encodeURIComponent("" + expertChangeRequestId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRejectExpertChangeRequest(_response);
        });
    }

    protected processRejectExpertChangeRequest(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * Получение списка членов комиссии
     * @param linkedWithCurrentCommission (optional) 
     * @param qualificationIds (optional) 
     * @param ascIds (optional) 
     * @param regionIds (optional) 
     * @param statuses (optional) 
     * @param searchField (optional) Поле, по которому осуществляется поиск
     * @param searchTerm (optional) Строка для поиска
     * @param page (optional) Страница, начиная с 1-й
     * @param pageSize (optional) Размер страницы, по умолчанию 10
     * @param sortOrder (optional) Направление сортировки, true - Asc, false - Desc
     * @param sortField (optional) Сортируемое поле
     * @return Success
     */
    getExperts(linkedWithCurrentCommission: boolean | undefined, qualificationIds: string[] | null | undefined, ascIds: string[] | null | undefined, regionIds: number[] | null | undefined, statuses: ExpertStatus[] | null | undefined, searchField: string | null | undefined, searchTerm: string | null | undefined, page: number | undefined, pageSize: number | undefined, sortOrder: boolean | null | undefined, sortField: string | null | undefined): Promise<Experts> {
        let url_ = this.baseUrl + "/api/v1/experts?";
        if (linkedWithCurrentCommission === null)
            throw new Error("The parameter 'linkedWithCurrentCommission' cannot be null.");
        else if (linkedWithCurrentCommission !== undefined)
            url_ += "linkedWithCurrentCommission=" + encodeURIComponent("" + linkedWithCurrentCommission) + "&";
        if (qualificationIds !== undefined && qualificationIds !== null)
            qualificationIds && qualificationIds.forEach(item => { url_ += "qualificationIds=" + encodeURIComponent("" + item) + "&"; });
        if (ascIds !== undefined && ascIds !== null)
            ascIds && ascIds.forEach(item => { url_ += "ascIds=" + encodeURIComponent("" + item) + "&"; });
        if (regionIds !== undefined && regionIds !== null)
            regionIds && regionIds.forEach(item => { url_ += "regionIds=" + encodeURIComponent("" + item) + "&"; });
        if (statuses !== undefined && statuses !== null)
            statuses && statuses.forEach(item => { url_ += "statuses=" + encodeURIComponent("" + item) + "&"; });
        if (searchField !== undefined && searchField !== null)
            url_ += "searchField=" + encodeURIComponent("" + searchField) + "&";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortOrder !== undefined && sortOrder !== null)
            url_ += "sortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        if (sortField !== undefined && sortField !== null)
            url_ += "sortField=" + encodeURIComponent("" + sortField) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetExperts(_response);
        });
    }

    protected processGetExperts(response: Response): Promise<Experts> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Experts.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("\u0412\u043d\u0443\u0442\u0440\u0435\u043d\u043d\u044f\u044f \u043e\u0448\u0438\u0431\u043a\u0430 \u0441\u0435\u0440\u0432\u0435\u0440\u0430.", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Experts>(<any>null);
    }

    /**
     * Получение списка членов комиссии назначенных на АД
     * @param page (optional) Страница, начиная с 1-й
     * @param pageSize (optional) Размер страницы, по умолчанию 10
     * @param sortOrder (optional) Направление сортировки, true - Asc, false - Desc
     * @param sortField (optional) Сортируемое поле
     * @return Success
     */
    getExpertsForDay(examDayId: string, page: number | undefined, pageSize: number | undefined, sortOrder: boolean | null | undefined, sortField: string | null | undefined): Promise<Experts> {
        let url_ = this.baseUrl + "/api/v1/experts/for-day/{examDayId}?";
        if (examDayId === undefined || examDayId === null)
            throw new Error("The parameter 'examDayId' must be defined.");
        url_ = url_.replace("{examDayId}", encodeURIComponent("" + examDayId));
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortOrder !== undefined && sortOrder !== null)
            url_ += "sortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        if (sortField !== undefined && sortField !== null)
            url_ += "sortField=" + encodeURIComponent("" + sortField) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetExpertsForDay(_response);
        });
    }

    protected processGetExpertsForDay(response: Response): Promise<Experts> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Experts.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("\u0412\u043d\u0443\u0442\u0440\u0435\u043d\u043d\u044f\u044f \u043e\u0448\u0438\u0431\u043a\u0430 \u0441\u0435\u0440\u0432\u0435\u0440\u0430.", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Experts>(<any>null);
    }

    /**
     * Возвращает члена комиссии
     * @return Успешно.
     */
    getExpert(expertId: string): Promise<ExpertDetails> {
        let url_ = this.baseUrl + "/api/v1/experts/{expertId}";
        if (expertId === undefined || expertId === null)
            throw new Error("The parameter 'expertId' must be defined.");
        url_ = url_.replace("{expertId}", encodeURIComponent("" + expertId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetExpert(_response);
        });
    }

    protected processGetExpert(response: Response): Promise<ExpertDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExpertDetails.fromJS(resultData200);
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("\u0412\u043d\u0443\u0442\u0440\u0435\u043d\u043d\u044f\u044f \u043e\u0448\u0438\u0431\u043a\u0430 \u0441\u0435\u0440\u0432\u0435\u0440\u0430.", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExpertDetails>(<any>null);
    }

    /**
     * Возвращает список свидетельств члена комиссии
     * @return Успешно.
     */
    getExpertCertificates2(expertId: string): Promise<ExpertCertificate[]> {
        let url_ = this.baseUrl + "/api/v1/experts/{expertId}/certificates";
        if (expertId === undefined || expertId === null)
            throw new Error("The parameter 'expertId' must be defined.");
        url_ = url_.replace("{expertId}", encodeURIComponent("" + expertId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetExpertCertificates2(_response);
        });
    }

    protected processGetExpertCertificates2(response: Response): Promise<ExpertCertificate[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ExpertCertificate.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("\u0412\u043d\u0443\u0442\u0440\u0435\u043d\u043d\u044f\u044f \u043e\u0448\u0438\u0431\u043a\u0430 \u0441\u0435\u0440\u0432\u0435\u0440\u0430.", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExpertCertificate[]>(<any>null);
    }

    /**
     * Возвращает аккредитации в которых принимал участие член комиссии
     * @param qualificationIds (optional) 
     * @param attestationSubCommissionIds (optional) 
     * @param accreditationCenterIds (optional) 
     * @param filteredExamStatus (optional) 
     * @param from (optional) Дата аккредитации, с
     * @param to (optional) Дата аккредитации, по
     * @param page (optional) Страница, начиная с 1-й
     * @param pageSize (optional) Размер страницы, по умолчанию 10
     * @param sortOrder (optional) Направление сортировки, true - Asc, false - Desc
     * @param sortField (optional) Сортируемое поле
     * @return Успешно.
     */
    getExpertExams(expertId: string | null, qualificationIds: string[] | null | undefined, attestationSubCommissionIds: string[] | null | undefined, accreditationCenterIds: string[] | null | undefined, filteredExamStatus: FilteredExamStatus | undefined, from: moment.Moment | null | undefined, to: moment.Moment | null | undefined, page: number | undefined, pageSize: number | undefined, sortOrder: boolean | null | undefined, sortField: string | null | undefined): Promise<ExamList> {
        let url_ = this.baseUrl + "/api/v1/experts/{expertId}/exams?";
        if (expertId === undefined || expertId === null)
            throw new Error("The parameter 'expertId' must be defined.");
        url_ = url_.replace("{expertId}", encodeURIComponent("" + expertId));
        if (qualificationIds !== undefined && qualificationIds !== null)
            qualificationIds && qualificationIds.forEach(item => { url_ += "qualificationIds=" + encodeURIComponent("" + item) + "&"; });
        if (attestationSubCommissionIds !== undefined && attestationSubCommissionIds !== null)
            attestationSubCommissionIds && attestationSubCommissionIds.forEach(item => { url_ += "attestationSubCommissionIds=" + encodeURIComponent("" + item) + "&"; });
        if (accreditationCenterIds !== undefined && accreditationCenterIds !== null)
            accreditationCenterIds && accreditationCenterIds.forEach(item => { url_ += "accreditationCenterIds=" + encodeURIComponent("" + item) + "&"; });
        if (filteredExamStatus === null)
            throw new Error("The parameter 'filteredExamStatus' cannot be null.");
        else if (filteredExamStatus !== undefined)
            url_ += "filteredExamStatus=" + encodeURIComponent("" + filteredExamStatus) + "&";
        if (from !== undefined && from !== null)
            url_ += "from=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to !== undefined && to !== null)
            url_ += "to=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortOrder !== undefined && sortOrder !== null)
            url_ += "sortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        if (sortField !== undefined && sortField !== null)
            url_ += "sortField=" + encodeURIComponent("" + sortField) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetExpertExams(_response);
        });
    }

    protected processGetExpertExams(response: Response): Promise<ExamList> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExamList.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("\u0412\u043d\u0443\u0442\u0440\u0435\u043d\u043d\u044f\u044f \u043e\u0448\u0438\u0431\u043a\u0430 \u0441\u0435\u0440\u0432\u0435\u0440\u0430.", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExamList>(<any>null);
    }

    /**
     * Добавить специальность и стаж члену комиссии
     * @return Success
     */
    addExpertQualification(expertId: string, body: AddExpertQualification): Promise<ExpertDetails> {
        let url_ = this.baseUrl + "/api/v1/experts/{expertId}/qualification";
        if (expertId === undefined || expertId === null)
            throw new Error("The parameter 'expertId' must be defined.");
        url_ = url_.replace("{expertId}", encodeURIComponent("" + expertId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddExpertQualification(_response);
        });
    }

    protected processAddExpertQualification(response: Response): Promise<ExpertDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExpertDetails.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExpertDetails>(<any>null);
    }

    /**
     * Обновляет стаж у специальности члену комиссии
     * @return Success
     */
    updateExpertQualification(expertId: string, body: UpdateExpertQualification): Promise<ExpertDetails> {
        let url_ = this.baseUrl + "/api/v1/experts/{expertId}/qualification";
        if (expertId === undefined || expertId === null)
            throw new Error("The parameter 'expertId' must be defined.");
        url_ = url_.replace("{expertId}", encodeURIComponent("" + expertId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateExpertQualification(_response);
        });
    }

    protected processUpdateExpertQualification(response: Response): Promise<ExpertDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExpertDetails.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExpertDetails>(<any>null);
    }

    /**
     * Удаляет специальность и стаж члену комиссии
     * @return Success
     */
    removeExpertQualification(expertId: string, qualificationId: string): Promise<ExpertDetails> {
        let url_ = this.baseUrl + "/api/v1/experts/{expertId}/qualification/{qualificationId}";
        if (expertId === undefined || expertId === null)
            throw new Error("The parameter 'expertId' must be defined.");
        url_ = url_.replace("{expertId}", encodeURIComponent("" + expertId));
        if (qualificationId === undefined || qualificationId === null)
            throw new Error("The parameter 'qualificationId' must be defined.");
        url_ = url_.replace("{qualificationId}", encodeURIComponent("" + qualificationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRemoveExpertQualification(_response);
        });
    }

    protected processRemoveExpertQualification(response: Response): Promise<ExpertDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExpertDetails.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ApiError.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExpertDetails>(<any>null);
    }

    /**
     * Возвращает список специальностей
     * @param occupationalStandardId (optional) 
     * @param readyToUse (optional) 
     * @param residency (optional) 
     * @param searchField (optional) Поле, по которому осуществляется поиск
     * @param searchTerm (optional) Строка для поиска
     * @param page (optional) Страница, начиная с 1-й
     * @param pageSize (optional) Размер страницы, по умолчанию 10
     * @param sortOrder (optional) Направление сортировки, true - Asc, false - Desc
     * @param sortField (optional) Сортируемое поле
     * @return Success
     */
    getQualifications(occupationalStandardId: string | null | undefined, readyToUse: boolean | null | undefined, residency: boolean | null | undefined, searchField: string | null | undefined, searchTerm: string | null | undefined, page: number | undefined, pageSize: number | undefined, sortOrder: boolean | null | undefined, sortField: string | null | undefined): Promise<QualificationInfoList> {
        let url_ = this.baseUrl + "/api/v1/qualifications?";
        if (occupationalStandardId !== undefined && occupationalStandardId !== null)
            url_ += "occupationalStandardId=" + encodeURIComponent("" + occupationalStandardId) + "&";
        if (readyToUse !== undefined && readyToUse !== null)
            url_ += "readyToUse=" + encodeURIComponent("" + readyToUse) + "&";
        if (residency !== undefined && residency !== null)
            url_ += "residency=" + encodeURIComponent("" + residency) + "&";
        if (searchField !== undefined && searchField !== null)
            url_ += "searchField=" + encodeURIComponent("" + searchField) + "&";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortOrder !== undefined && sortOrder !== null)
            url_ += "sortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        if (sortField !== undefined && sortField !== null)
            url_ += "sortField=" + encodeURIComponent("" + sortField) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetQualifications(_response);
        });
    }

    protected processGetQualifications(response: Response): Promise<QualificationInfoList> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QualificationInfoList.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ApiError.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ApiError.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QualificationInfoList>(<any>null);
    }
}

export class AccreditationCenter implements IAccreditationCenter {
    id!: string;
    regNumber!: string;
    name!: string;
    fullName!: string;
    city!: string;
    address!: string;
    regionId!: number;
    regionName!: string;
    qualifications!: AccreditationCenterQualification[];

    constructor(data?: IAccreditationCenter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.qualifications = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.regNumber = _data["regNumber"];
            this.name = _data["name"];
            this.fullName = _data["fullName"];
            this.city = _data["city"];
            this.address = _data["address"];
            this.regionId = _data["regionId"];
            this.regionName = _data["regionName"];
            if (Array.isArray(_data["qualifications"])) {
                this.qualifications = [] as any;
                for (let item of _data["qualifications"])
                    this.qualifications!.push(AccreditationCenterQualification.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AccreditationCenter {
        data = typeof data === 'object' ? data : {};
        let result = new AccreditationCenter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["regNumber"] = this.regNumber;
        data["name"] = this.name;
        data["fullName"] = this.fullName;
        data["city"] = this.city;
        data["address"] = this.address;
        data["regionId"] = this.regionId;
        data["regionName"] = this.regionName;
        if (Array.isArray(this.qualifications)) {
            data["qualifications"] = [];
            for (let item of this.qualifications)
                data["qualifications"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IAccreditationCenter {
    id: string;
    regNumber: string;
    name: string;
    fullName: string;
    city: string;
    address: string;
    regionId: number;
    regionName: string;
    qualifications: AccreditationCenterQualification[];
}

export class AccreditationCenterDetails implements IAccreditationCenterDetails {
    id!: string;
    regNumber!: string;
    name!: string;
    fullName!: string;
    city!: string;
    address!: string;
    regionId!: number;
    regionName!: string;
    qualifications!: AccreditationCenterQualification[];
    secretaryPhone?: string | undefined;
    secretaryEmail?: string | undefined;
    secretaryFullName?: string | undefined;

    constructor(data?: IAccreditationCenterDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.qualifications = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.regNumber = _data["regNumber"];
            this.name = _data["name"];
            this.fullName = _data["fullName"];
            this.city = _data["city"];
            this.address = _data["address"];
            this.regionId = _data["regionId"];
            this.regionName = _data["regionName"];
            if (Array.isArray(_data["qualifications"])) {
                this.qualifications = [] as any;
                for (let item of _data["qualifications"])
                    this.qualifications!.push(AccreditationCenterQualification.fromJS(item));
            }
            this.secretaryPhone = _data["secretaryPhone"];
            this.secretaryEmail = _data["secretaryEmail"];
            this.secretaryFullName = _data["secretaryFullName"];
        }
    }

    static fromJS(data: any): AccreditationCenterDetails {
        data = typeof data === 'object' ? data : {};
        let result = new AccreditationCenterDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["regNumber"] = this.regNumber;
        data["name"] = this.name;
        data["fullName"] = this.fullName;
        data["city"] = this.city;
        data["address"] = this.address;
        data["regionId"] = this.regionId;
        data["regionName"] = this.regionName;
        if (Array.isArray(this.qualifications)) {
            data["qualifications"] = [];
            for (let item of this.qualifications)
                data["qualifications"].push(item.toJSON());
        }
        data["secretaryPhone"] = this.secretaryPhone;
        data["secretaryEmail"] = this.secretaryEmail;
        data["secretaryFullName"] = this.secretaryFullName;
        return data; 
    }
}

export interface IAccreditationCenterDetails {
    id: string;
    regNumber: string;
    name: string;
    fullName: string;
    city: string;
    address: string;
    regionId: number;
    regionName: string;
    qualifications: AccreditationCenterQualification[];
    secretaryPhone?: string | undefined;
    secretaryEmail?: string | undefined;
    secretaryFullName?: string | undefined;
}

export class AccreditationCenterQualification implements IAccreditationCenterQualification {
    id!: string;
    regNumber!: string;
    title!: string;
    audienceCapacity!: number;

    constructor(data?: IAccreditationCenterQualification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.regNumber = _data["regNumber"];
            this.title = _data["title"];
            this.audienceCapacity = _data["audienceCapacity"];
        }
    }

    static fromJS(data: any): AccreditationCenterQualification {
        data = typeof data === 'object' ? data : {};
        let result = new AccreditationCenterQualification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["regNumber"] = this.regNumber;
        data["title"] = this.title;
        data["audienceCapacity"] = this.audienceCapacity;
        return data; 
    }
}

export interface IAccreditationCenterQualification {
    id: string;
    regNumber: string;
    title: string;
    audienceCapacity: number;
}

export class AccreditationCenters implements IAccreditationCenters {
    items!: AccreditationCenter[];
    page!: number;
    pageSize!: number;
    total!: number;

    constructor(data?: IAccreditationCenters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AccreditationCenter.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.total = _data["total"];
        }
    }

    static fromJS(data: any): AccreditationCenters {
        data = typeof data === 'object' ? data : {};
        let result = new AccreditationCenters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["total"] = this.total;
        return data; 
    }
}

export interface IAccreditationCenters {
    items: AccreditationCenter[];
    page: number;
    pageSize: number;
    total: number;
}

export class AddExpertQualification implements IAddExpertQualification {
    qualificationId!: string;
    /** Дата начала стажа работы */
    experienceStartDate!: moment.Moment;

    constructor(data?: IAddExpertQualification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.qualificationId = _data["qualificationId"];
            this.experienceStartDate = _data["experienceStartDate"] ? moment(_data["experienceStartDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AddExpertQualification {
        data = typeof data === 'object' ? data : {};
        let result = new AddExpertQualification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["qualificationId"] = this.qualificationId;
        data["experienceStartDate"] = this.experienceStartDate ? this.experienceStartDate.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IAddExpertQualification {
    qualificationId: string;
    /** Дата начала стажа работы */
    experienceStartDate: moment.Moment;
}

export class ApiError implements IApiError {
    code!: number;
    type!: AppExceptionType;
    message!: string;
    failures?: { [key: string]: string[]; } | undefined;

    constructor(data?: IApiError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.type = _data["type"];
            this.message = _data["message"];
            if (_data["failures"]) {
                this.failures = {} as any;
                for (let key in _data["failures"]) {
                    if (_data["failures"].hasOwnProperty(key))
                        (<any>this.failures)![key] = _data["failures"][key] !== undefined ? _data["failures"][key] : [];
                }
            }
        }
    }

    static fromJS(data: any): ApiError {
        data = typeof data === 'object' ? data : {};
        let result = new ApiError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["type"] = this.type;
        data["message"] = this.message;
        if (this.failures) {
            data["failures"] = {};
            for (let key in this.failures) {
                if (this.failures.hasOwnProperty(key))
                    (<any>data["failures"])[key] = this.failures[key];
            }
        }
        return data; 
    }
}

export interface IApiError {
    code: number;
    type: AppExceptionType;
    message: string;
    failures?: { [key: string]: string[]; } | undefined;
}

export enum AppExceptionType {
    Unspecified = "unspecified",
    Validation = "validation",
    NotFound = "notFound",
    AlreadyExists = "alreadyExists",
    WrongVerificationCode = "wrongVerificationCode",
    TooManyRequests = "tooManyRequests",
    WrongCredentials = "wrongCredentials",
    AuthUserNotFound = "authUserNotFound",
    Forbidden = "forbidden",
    Captcha = "captcha",
    WrongIp = "wrongIp",
}

export class Applicant implements IApplicant {
    id!: string;
    /** Имя */
    firstName!: string;
    /** Фамилия */
    lastName!: string;
    /** Отчество */
    middleName?: string | undefined;
    sex!: Sex;
    birthDate!: moment.Moment;
    email!: string;
    emailConfirmed!: boolean;
    phone!: string;
    /** СНИЛС */
    snils!: string;
    regionId!: number;
    regionName!: string;
    qualificationId!: string;
    citizenshipType?: CitizenshipType;
    citizenshipCountryId?: number | undefined;
    citizenshipCountryName?: string | undefined;
    militaryRelationship?: MilitaryRelationshipType;

    constructor(data?: IApplicant) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.middleName = _data["middleName"];
            this.sex = _data["sex"];
            this.birthDate = _data["birthDate"] ? moment(_data["birthDate"].toString()) : <any>undefined;
            this.email = _data["email"];
            this.emailConfirmed = _data["emailConfirmed"];
            this.phone = _data["phone"];
            this.snils = _data["snils"];
            this.regionId = _data["regionId"];
            this.regionName = _data["regionName"];
            this.qualificationId = _data["qualificationId"];
            this.citizenshipType = _data["citizenshipType"];
            this.citizenshipCountryId = _data["citizenshipCountryId"];
            this.citizenshipCountryName = _data["citizenshipCountryName"];
            this.militaryRelationship = _data["militaryRelationship"];
        }
    }

    static fromJS(data: any): Applicant {
        data = typeof data === 'object' ? data : {};
        let result = new Applicant();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["middleName"] = this.middleName;
        data["sex"] = this.sex;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["email"] = this.email;
        data["emailConfirmed"] = this.emailConfirmed;
        data["phone"] = this.phone;
        data["snils"] = this.snils;
        data["regionId"] = this.regionId;
        data["regionName"] = this.regionName;
        data["qualificationId"] = this.qualificationId;
        data["citizenshipType"] = this.citizenshipType;
        data["citizenshipCountryId"] = this.citizenshipCountryId;
        data["citizenshipCountryName"] = this.citizenshipCountryName;
        data["militaryRelationship"] = this.militaryRelationship;
        return data; 
    }
}

export interface IApplicant {
    id: string;
    /** Имя */
    firstName: string;
    /** Фамилия */
    lastName: string;
    /** Отчество */
    middleName?: string | undefined;
    sex: Sex;
    birthDate: moment.Moment;
    email: string;
    emailConfirmed: boolean;
    phone: string;
    /** СНИЛС */
    snils: string;
    regionId: number;
    regionName: string;
    qualificationId: string;
    citizenshipType?: CitizenshipType;
    citizenshipCountryId?: number | undefined;
    citizenshipCountryName?: string | undefined;
    militaryRelationship?: MilitaryRelationshipType;
}

export class ApplicantDiploma implements IApplicantDiploma {
    type!: DiplomaType;
    /** серия/номер */
    serialNumber!: string;
    /** кем выдан */
    issuedBy!: string;
    /** Дата выдачи, время должно быть 00ч. 00м. 00с. по UTC */
    dateOfIssue!: moment.Moment;

    constructor(data?: IApplicantDiploma) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.serialNumber = _data["serialNumber"];
            this.issuedBy = _data["issuedBy"];
            this.dateOfIssue = _data["dateOfIssue"] ? moment(_data["dateOfIssue"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ApplicantDiploma {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicantDiploma();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["serialNumber"] = this.serialNumber;
        data["issuedBy"] = this.issuedBy;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IApplicantDiploma {
    type: DiplomaType;
    /** серия/номер */
    serialNumber: string;
    /** кем выдан */
    issuedBy: string;
    /** Дата выдачи, время должно быть 00ч. 00м. 00с. по UTC */
    dateOfIssue: moment.Moment;
}

export class ApplicantExam implements IApplicantExam {
    examId!: string;
    date!: moment.Moment;
    lastDate!: moment.Moment;
    reviewComment?: string | undefined;
    qualificationTitle!: string;
    stagesNumber!: number;
    accreditationCenterName!: string;
    attestationSubCommissionName!: string;
    address!: string;
    attestationCommissionName!: string;
    city!: string;
    region!: string;
    examStatus!: ExamStatus;
    examApplicationStatus?: ExamApplicationStatus;
    applicationSubmitDate?: moment.Moment | undefined;
    examApplicationId?: string | undefined;
    /** Номер текущего этапа */
    currentStageNumber?: number | undefined;
    /** Дата проведения первого дня текущего этапа */
    currentStageFirstDayDate?: moment.Moment | undefined;
    /** Дата проведения последнего дня текущего этапа */
    currentStageLastDayDate?: moment.Moment | undefined;
    /** Номер пересдачи если она была, показывать в случае больше нуля */
    currentStageAttemptNumber?: number | undefined;

    constructor(data?: IApplicantExam) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.examId = _data["examId"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>undefined;
            this.lastDate = _data["lastDate"] ? moment(_data["lastDate"].toString()) : <any>undefined;
            this.reviewComment = _data["reviewComment"];
            this.qualificationTitle = _data["qualificationTitle"];
            this.stagesNumber = _data["stagesNumber"];
            this.accreditationCenterName = _data["accreditationCenterName"];
            this.attestationSubCommissionName = _data["attestationSubCommissionName"];
            this.address = _data["address"];
            this.attestationCommissionName = _data["attestationCommissionName"];
            this.city = _data["city"];
            this.region = _data["region"];
            this.examStatus = _data["examStatus"];
            this.examApplicationStatus = _data["examApplicationStatus"];
            this.applicationSubmitDate = _data["applicationSubmitDate"] ? moment(_data["applicationSubmitDate"].toString()) : <any>undefined;
            this.examApplicationId = _data["examApplicationId"];
            this.currentStageNumber = _data["currentStageNumber"];
            this.currentStageFirstDayDate = _data["currentStageFirstDayDate"] ? moment(_data["currentStageFirstDayDate"].toString()) : <any>undefined;
            this.currentStageLastDayDate = _data["currentStageLastDayDate"] ? moment(_data["currentStageLastDayDate"].toString()) : <any>undefined;
            this.currentStageAttemptNumber = _data["currentStageAttemptNumber"];
        }
    }

    static fromJS(data: any): ApplicantExam {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicantExam();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["examId"] = this.examId;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["lastDate"] = this.lastDate ? this.lastDate.toISOString() : <any>undefined;
        data["reviewComment"] = this.reviewComment;
        data["qualificationTitle"] = this.qualificationTitle;
        data["stagesNumber"] = this.stagesNumber;
        data["accreditationCenterName"] = this.accreditationCenterName;
        data["attestationSubCommissionName"] = this.attestationSubCommissionName;
        data["address"] = this.address;
        data["attestationCommissionName"] = this.attestationCommissionName;
        data["city"] = this.city;
        data["region"] = this.region;
        data["examStatus"] = this.examStatus;
        data["examApplicationStatus"] = this.examApplicationStatus;
        data["applicationSubmitDate"] = this.applicationSubmitDate ? this.applicationSubmitDate.toISOString() : <any>undefined;
        data["examApplicationId"] = this.examApplicationId;
        data["currentStageNumber"] = this.currentStageNumber;
        data["currentStageFirstDayDate"] = this.currentStageFirstDayDate ? this.currentStageFirstDayDate.toISOString() : <any>undefined;
        data["currentStageLastDayDate"] = this.currentStageLastDayDate ? this.currentStageLastDayDate.toISOString() : <any>undefined;
        data["currentStageAttemptNumber"] = this.currentStageAttemptNumber;
        return data; 
    }
}

export interface IApplicantExam {
    examId: string;
    date: moment.Moment;
    lastDate: moment.Moment;
    reviewComment?: string | undefined;
    qualificationTitle: string;
    stagesNumber: number;
    accreditationCenterName: string;
    attestationSubCommissionName: string;
    address: string;
    attestationCommissionName: string;
    city: string;
    region: string;
    examStatus: ExamStatus;
    examApplicationStatus?: ExamApplicationStatus;
    applicationSubmitDate?: moment.Moment | undefined;
    examApplicationId?: string | undefined;
    /** Номер текущего этапа */
    currentStageNumber?: number | undefined;
    /** Дата проведения первого дня текущего этапа */
    currentStageFirstDayDate?: moment.Moment | undefined;
    /** Дата проведения последнего дня текущего этапа */
    currentStageLastDayDate?: moment.Moment | undefined;
    /** Номер пересдачи если она была, показывать в случае больше нуля */
    currentStageAttemptNumber?: number | undefined;
}

export class ApplicantExamList implements IApplicantExamList {
    items!: ApplicantExam[];
    page!: number;
    pageSize!: number;
    total!: number;

    constructor(data?: IApplicantExamList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ApplicantExam.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.total = _data["total"];
        }
    }

    static fromJS(data: any): ApplicantExamList {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicantExamList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["total"] = this.total;
        return data; 
    }
}

export interface IApplicantExamList {
    items: ApplicantExam[];
    page: number;
    pageSize: number;
    total: number;
}

export class ApplicantIdentityDoc implements IApplicantIdentityDoc {
    identityDocType!: IdentityDocType;
    passport?: ApplicantPassport;
    otherIdentity?: ApplicantOtherIdentity;

    constructor(data?: IApplicantIdentityDoc) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.identityDocType = _data["identityDocType"];
            this.passport = _data["passport"] ? ApplicantPassport.fromJS(_data["passport"]) : <any>undefined;
            this.otherIdentity = _data["otherIdentity"] ? ApplicantOtherIdentity.fromJS(_data["otherIdentity"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ApplicantIdentityDoc {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicantIdentityDoc();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identityDocType"] = this.identityDocType;
        data["passport"] = this.passport ? this.passport.toJSON() : <any>undefined;
        data["otherIdentity"] = this.otherIdentity ? this.otherIdentity.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IApplicantIdentityDoc {
    identityDocType: IdentityDocType;
    passport?: ApplicantPassport;
    otherIdentity?: ApplicantOtherIdentity;
}

/** Другой документ */
export class ApplicantOtherIdentity implements IApplicantOtherIdentity {
    /** данные документа */
    data!: string;

    constructor(data?: IApplicantOtherIdentity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): ApplicantOtherIdentity {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicantOtherIdentity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data;
        return data; 
    }
}

/** Другой документ */
export interface IApplicantOtherIdentity {
    /** данные документа */
    data: string;
}

/** паспорт */
export class ApplicantPassport implements IApplicantPassport {
    /** серия/номер */
    serialNumber!: string;
    /** кем выдан */
    issuedBy!: string;
    /** Дата выдачи, время должно быть 00ч. 00м. 00с. по UTC */
    dateOfIssue!: moment.Moment;
    /** адрес регистрации */
    registrationAddress!: string;

    constructor(data?: IApplicantPassport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serialNumber = _data["serialNumber"];
            this.issuedBy = _data["issuedBy"];
            this.dateOfIssue = _data["dateOfIssue"] ? moment(_data["dateOfIssue"].toString()) : <any>undefined;
            this.registrationAddress = _data["registrationAddress"];
        }
    }

    static fromJS(data: any): ApplicantPassport {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicantPassport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serialNumber"] = this.serialNumber;
        data["issuedBy"] = this.issuedBy;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toISOString() : <any>undefined;
        data["registrationAddress"] = this.registrationAddress;
        return data; 
    }
}

/** паспорт */
export interface IApplicantPassport {
    /** серия/номер */
    serialNumber: string;
    /** кем выдан */
    issuedBy: string;
    /** Дата выдачи, время должно быть 00ч. 00м. 00с. по UTC */
    dateOfIssue: moment.Moment;
    /** адрес регистрации */
    registrationAddress: string;
}

export class ApplicantQualification implements IApplicantQualification {
    applicantId!: string;
    examId!: string;
    examApplicationId!: string;
    title!: string;
    stagesNumber!: number;
    /** Регистрационный номер специальности */
    regNumber!: string;
    /** Дата присвоения */
    issueDate!: moment.Moment;
    /** Дата окончания действия */
    expireDate!: moment.Moment;
    /** Регистрационный номер свидетельства */
    certRegNumber!: string;

    constructor(data?: IApplicantQualification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicantId = _data["applicantId"];
            this.examId = _data["examId"];
            this.examApplicationId = _data["examApplicationId"];
            this.title = _data["title"];
            this.stagesNumber = _data["stagesNumber"];
            this.regNumber = _data["regNumber"];
            this.issueDate = _data["issueDate"] ? moment(_data["issueDate"].toString()) : <any>undefined;
            this.expireDate = _data["expireDate"] ? moment(_data["expireDate"].toString()) : <any>undefined;
            this.certRegNumber = _data["certRegNumber"];
        }
    }

    static fromJS(data: any): ApplicantQualification {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicantQualification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicantId"] = this.applicantId;
        data["examId"] = this.examId;
        data["examApplicationId"] = this.examApplicationId;
        data["title"] = this.title;
        data["stagesNumber"] = this.stagesNumber;
        data["regNumber"] = this.regNumber;
        data["issueDate"] = this.issueDate ? this.issueDate.toISOString() : <any>undefined;
        data["expireDate"] = this.expireDate ? this.expireDate.toISOString() : <any>undefined;
        data["certRegNumber"] = this.certRegNumber;
        return data; 
    }
}

export interface IApplicantQualification {
    applicantId: string;
    examId: string;
    examApplicationId: string;
    title: string;
    stagesNumber: number;
    /** Регистрационный номер специальности */
    regNumber: string;
    /** Дата присвоения */
    issueDate: moment.Moment;
    /** Дата окончания действия */
    expireDate: moment.Moment;
    /** Регистрационный номер свидетельства */
    certRegNumber: string;
}

export class ApplicantQualificationDetails implements IApplicantQualificationDetails {
    applicantId!: string;
    examId!: string;
    examApplicationId!: string;
    title!: string;
    stagesNumber!: number;
    /** Регистрационный номер специальности */
    regNumber!: string;
    /** Дата присвоения */
    issueDate!: moment.Moment;
    /** Дата окончания действия */
    expireDate!: moment.Moment;
    /** Регистрационный номер свидетельства */
    certRegNumber!: string;
    examDate!: moment.Moment;
    accreditationCenterName!: string;
    acFullName!: string;
    regionName!: string;
    /** СВИДЕТЕЛЬСТВО О КВАЛИФИКАЦИИ */
    certificateUrl?: string | undefined;

    constructor(data?: IApplicantQualificationDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicantId = _data["applicantId"];
            this.examId = _data["examId"];
            this.examApplicationId = _data["examApplicationId"];
            this.title = _data["title"];
            this.stagesNumber = _data["stagesNumber"];
            this.regNumber = _data["regNumber"];
            this.issueDate = _data["issueDate"] ? moment(_data["issueDate"].toString()) : <any>undefined;
            this.expireDate = _data["expireDate"] ? moment(_data["expireDate"].toString()) : <any>undefined;
            this.certRegNumber = _data["certRegNumber"];
            this.examDate = _data["examDate"] ? moment(_data["examDate"].toString()) : <any>undefined;
            this.accreditationCenterName = _data["accreditationCenterName"];
            this.acFullName = _data["acFullName"];
            this.regionName = _data["regionName"];
            this.certificateUrl = _data["certificateUrl"];
        }
    }

    static fromJS(data: any): ApplicantQualificationDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicantQualificationDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicantId"] = this.applicantId;
        data["examId"] = this.examId;
        data["examApplicationId"] = this.examApplicationId;
        data["title"] = this.title;
        data["stagesNumber"] = this.stagesNumber;
        data["regNumber"] = this.regNumber;
        data["issueDate"] = this.issueDate ? this.issueDate.toISOString() : <any>undefined;
        data["expireDate"] = this.expireDate ? this.expireDate.toISOString() : <any>undefined;
        data["certRegNumber"] = this.certRegNumber;
        data["examDate"] = this.examDate ? this.examDate.toISOString() : <any>undefined;
        data["accreditationCenterName"] = this.accreditationCenterName;
        data["acFullName"] = this.acFullName;
        data["regionName"] = this.regionName;
        data["certificateUrl"] = this.certificateUrl;
        return data; 
    }
}

export interface IApplicantQualificationDetails {
    applicantId: string;
    examId: string;
    examApplicationId: string;
    title: string;
    stagesNumber: number;
    /** Регистрационный номер специальности */
    regNumber: string;
    /** Дата присвоения */
    issueDate: moment.Moment;
    /** Дата окончания действия */
    expireDate: moment.Moment;
    /** Регистрационный номер свидетельства */
    certRegNumber: string;
    examDate: moment.Moment;
    accreditationCenterName: string;
    acFullName: string;
    regionName: string;
    /** СВИДЕТЕЛЬСТВО О КВАЛИФИКАЦИИ */
    certificateUrl?: string | undefined;
}

export class Applicants implements IApplicants {
    items!: Applicant[];
    page!: number;
    pageSize!: number;
    total!: number;

    constructor(data?: IApplicants) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(Applicant.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.total = _data["total"];
        }
    }

    static fromJS(data: any): Applicants {
        data = typeof data === 'object' ? data : {};
        let result = new Applicants();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["total"] = this.total;
        return data; 
    }
}

export interface IApplicants {
    items: Applicant[];
    page: number;
    pageSize: number;
    total: number;
}

export class ApprovalProcessStep implements IApprovalProcessStep {
    completionDateTime?: moment.Moment | undefined;
    expertId?: string | undefined;
    label!: string;
    value!: string;

    constructor(data?: IApprovalProcessStep) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.completionDateTime = _data["completionDateTime"] ? moment(_data["completionDateTime"].toString()) : <any>undefined;
            this.expertId = _data["expertId"];
            this.label = _data["label"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): ApprovalProcessStep {
        data = typeof data === 'object' ? data : {};
        let result = new ApprovalProcessStep();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["completionDateTime"] = this.completionDateTime ? this.completionDateTime.toISOString() : <any>undefined;
        data["expertId"] = this.expertId;
        data["label"] = this.label;
        data["value"] = this.value;
        return data; 
    }
}

export interface IApprovalProcessStep {
    completionDateTime?: moment.Moment | undefined;
    expertId?: string | undefined;
    label: string;
    value: string;
}

export class ApproveExam implements IApproveExam {
    captcha?: string | undefined;
    code!: string;

    constructor(data?: IApproveExam) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.captcha = _data["captcha"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApproveExam {
        data = typeof data === 'object' ? data : {};
        let result = new ApproveExam();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["captcha"] = this.captcha;
        data["code"] = this.code;
        return data; 
    }
}

export interface IApproveExam {
    captcha?: string | undefined;
    code: string;
}

export class ApproveExpertChangeRequest implements IApproveExpertChangeRequest {
    captcha?: string | undefined;
    code!: string;

    constructor(data?: IApproveExpertChangeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.captcha = _data["captcha"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApproveExpertChangeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ApproveExpertChangeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["captcha"] = this.captcha;
        data["code"] = this.code;
        return data; 
    }
}

export interface IApproveExpertChangeRequest {
    captcha?: string | undefined;
    code: string;
}

export class AttestationCommission implements IAttestationCommission {
    id!: string;
    regNumber!: string;
    name!: string;
    fullName!: string;
    /** Город */
    city!: string;
    /** Id региона */
    regionId!: number;
    regionName!: string;
    secretaryFullName?: string | undefined;
    chairmanFullName?: string | undefined;

    constructor(data?: IAttestationCommission) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.regNumber = _data["regNumber"];
            this.name = _data["name"];
            this.fullName = _data["fullName"];
            this.city = _data["city"];
            this.regionId = _data["regionId"];
            this.regionName = _data["regionName"];
            this.secretaryFullName = _data["secretaryFullName"];
            this.chairmanFullName = _data["chairmanFullName"];
        }
    }

    static fromJS(data: any): AttestationCommission {
        data = typeof data === 'object' ? data : {};
        let result = new AttestationCommission();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["regNumber"] = this.regNumber;
        data["name"] = this.name;
        data["fullName"] = this.fullName;
        data["city"] = this.city;
        data["regionId"] = this.regionId;
        data["regionName"] = this.regionName;
        data["secretaryFullName"] = this.secretaryFullName;
        data["chairmanFullName"] = this.chairmanFullName;
        return data; 
    }
}

export interface IAttestationCommission {
    id: string;
    regNumber: string;
    name: string;
    fullName: string;
    /** Город */
    city: string;
    /** Id региона */
    regionId: number;
    regionName: string;
    secretaryFullName?: string | undefined;
    chairmanFullName?: string | undefined;
}

export class AttestationCommissionDetails implements IAttestationCommissionDetails {
    id!: string;
    regNumber!: string;
    name!: string;
    fullName!: string;
    /** Город */
    city!: string;
    /** Id региона */
    regionId!: number;
    regionName!: string;
    secretaryFullName?: string | undefined;
    chairmanFullName?: string | undefined;
    leaders!: Expert[];

    constructor(data?: IAttestationCommissionDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.leaders = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.regNumber = _data["regNumber"];
            this.name = _data["name"];
            this.fullName = _data["fullName"];
            this.city = _data["city"];
            this.regionId = _data["regionId"];
            this.regionName = _data["regionName"];
            this.secretaryFullName = _data["secretaryFullName"];
            this.chairmanFullName = _data["chairmanFullName"];
            if (Array.isArray(_data["leaders"])) {
                this.leaders = [] as any;
                for (let item of _data["leaders"])
                    this.leaders!.push(Expert.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AttestationCommissionDetails {
        data = typeof data === 'object' ? data : {};
        let result = new AttestationCommissionDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["regNumber"] = this.regNumber;
        data["name"] = this.name;
        data["fullName"] = this.fullName;
        data["city"] = this.city;
        data["regionId"] = this.regionId;
        data["regionName"] = this.regionName;
        data["secretaryFullName"] = this.secretaryFullName;
        data["chairmanFullName"] = this.chairmanFullName;
        if (Array.isArray(this.leaders)) {
            data["leaders"] = [];
            for (let item of this.leaders)
                data["leaders"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IAttestationCommissionDetails {
    id: string;
    regNumber: string;
    name: string;
    fullName: string;
    /** Город */
    city: string;
    /** Id региона */
    regionId: number;
    regionName: string;
    secretaryFullName?: string | undefined;
    chairmanFullName?: string | undefined;
    leaders: Expert[];
}

export class AttestationCommissions implements IAttestationCommissions {
    items!: AttestationCommission[];
    page!: number;
    pageSize!: number;
    total!: number;

    constructor(data?: IAttestationCommissions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AttestationCommission.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.total = _data["total"];
        }
    }

    static fromJS(data: any): AttestationCommissions {
        data = typeof data === 'object' ? data : {};
        let result = new AttestationCommissions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["total"] = this.total;
        return data; 
    }
}

export interface IAttestationCommissions {
    items: AttestationCommission[];
    page: number;
    pageSize: number;
    total: number;
}

export class AttestationSubCommission implements IAttestationSubCommission {
    id!: string;
    regNumber!: string;
    name!: string;
    fullName!: string;
    city!: string;
    address!: string;
    /** Id региона */
    regionId!: number;
    regionName!: string;
    qualificationId!: string;
    qualificationTitle!: string;
    qualificationStagesNumber!: number;
    secretaryFullName?: string | undefined;
    chairmanFullName?: string | undefined;
    newCommissionFormationCompleted?: boolean | undefined;

    constructor(data?: IAttestationSubCommission) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.regNumber = _data["regNumber"];
            this.name = _data["name"];
            this.fullName = _data["fullName"];
            this.city = _data["city"];
            this.address = _data["address"];
            this.regionId = _data["regionId"];
            this.regionName = _data["regionName"];
            this.qualificationId = _data["qualificationId"];
            this.qualificationTitle = _data["qualificationTitle"];
            this.qualificationStagesNumber = _data["qualificationStagesNumber"];
            this.secretaryFullName = _data["secretaryFullName"];
            this.chairmanFullName = _data["chairmanFullName"];
            this.newCommissionFormationCompleted = _data["newCommissionFormationCompleted"];
        }
    }

    static fromJS(data: any): AttestationSubCommission {
        data = typeof data === 'object' ? data : {};
        let result = new AttestationSubCommission();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["regNumber"] = this.regNumber;
        data["name"] = this.name;
        data["fullName"] = this.fullName;
        data["city"] = this.city;
        data["address"] = this.address;
        data["regionId"] = this.regionId;
        data["regionName"] = this.regionName;
        data["qualificationId"] = this.qualificationId;
        data["qualificationTitle"] = this.qualificationTitle;
        data["qualificationStagesNumber"] = this.qualificationStagesNumber;
        data["secretaryFullName"] = this.secretaryFullName;
        data["chairmanFullName"] = this.chairmanFullName;
        data["newCommissionFormationCompleted"] = this.newCommissionFormationCompleted;
        return data; 
    }
}

export interface IAttestationSubCommission {
    id: string;
    regNumber: string;
    name: string;
    fullName: string;
    city: string;
    address: string;
    /** Id региона */
    regionId: number;
    regionName: string;
    qualificationId: string;
    qualificationTitle: string;
    qualificationStagesNumber: number;
    secretaryFullName?: string | undefined;
    chairmanFullName?: string | undefined;
    newCommissionFormationCompleted?: boolean | undefined;
}

export class AttestationSubCommissionDetails implements IAttestationSubCommissionDetails {
    id!: string;
    regNumber!: string;
    name!: string;
    fullName!: string;
    city!: string;
    address!: string;
    /** Id региона */
    regionId!: number;
    regionName!: string;
    qualificationId!: string;
    qualificationTitle!: string;
    qualificationStagesNumber!: number;
    secretaryFullName?: string | undefined;
    chairmanFullName?: string | undefined;
    newCommissionFormationCompleted?: boolean | undefined;
    leaders!: Expert[];

    constructor(data?: IAttestationSubCommissionDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.leaders = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.regNumber = _data["regNumber"];
            this.name = _data["name"];
            this.fullName = _data["fullName"];
            this.city = _data["city"];
            this.address = _data["address"];
            this.regionId = _data["regionId"];
            this.regionName = _data["regionName"];
            this.qualificationId = _data["qualificationId"];
            this.qualificationTitle = _data["qualificationTitle"];
            this.qualificationStagesNumber = _data["qualificationStagesNumber"];
            this.secretaryFullName = _data["secretaryFullName"];
            this.chairmanFullName = _data["chairmanFullName"];
            this.newCommissionFormationCompleted = _data["newCommissionFormationCompleted"];
            if (Array.isArray(_data["leaders"])) {
                this.leaders = [] as any;
                for (let item of _data["leaders"])
                    this.leaders!.push(Expert.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AttestationSubCommissionDetails {
        data = typeof data === 'object' ? data : {};
        let result = new AttestationSubCommissionDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["regNumber"] = this.regNumber;
        data["name"] = this.name;
        data["fullName"] = this.fullName;
        data["city"] = this.city;
        data["address"] = this.address;
        data["regionId"] = this.regionId;
        data["regionName"] = this.regionName;
        data["qualificationId"] = this.qualificationId;
        data["qualificationTitle"] = this.qualificationTitle;
        data["qualificationStagesNumber"] = this.qualificationStagesNumber;
        data["secretaryFullName"] = this.secretaryFullName;
        data["chairmanFullName"] = this.chairmanFullName;
        data["newCommissionFormationCompleted"] = this.newCommissionFormationCompleted;
        if (Array.isArray(this.leaders)) {
            data["leaders"] = [];
            for (let item of this.leaders)
                data["leaders"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IAttestationSubCommissionDetails {
    id: string;
    regNumber: string;
    name: string;
    fullName: string;
    city: string;
    address: string;
    /** Id региона */
    regionId: number;
    regionName: string;
    qualificationId: string;
    qualificationTitle: string;
    qualificationStagesNumber: number;
    secretaryFullName?: string | undefined;
    chairmanFullName?: string | undefined;
    newCommissionFormationCompleted?: boolean | undefined;
    leaders: Expert[];
}

export class AttestationSubCommissionsList implements IAttestationSubCommissionsList {
    items!: AttestationSubCommission[];
    page!: number;
    pageSize!: number;
    total!: number;

    constructor(data?: IAttestationSubCommissionsList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AttestationSubCommission.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.total = _data["total"];
        }
    }

    static fromJS(data: any): AttestationSubCommissionsList {
        data = typeof data === 'object' ? data : {};
        let result = new AttestationSubCommissionsList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["total"] = this.total;
        return data; 
    }
}

export interface IAttestationSubCommissionsList {
    items: AttestationSubCommission[];
    page: number;
    pageSize: number;
    total: number;
}

export class AuthResult implements IAuthResult {
    profile!: LinkedExpert;
    token!: string;
    userAuthTokens?: UserAuthToken[] | undefined;

    constructor(data?: IAuthResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.profile = new LinkedExpert();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.profile = _data["profile"] ? LinkedExpert.fromJS(_data["profile"]) : new LinkedExpert();
            this.token = _data["token"];
            if (Array.isArray(_data["userAuthTokens"])) {
                this.userAuthTokens = [] as any;
                for (let item of _data["userAuthTokens"])
                    this.userAuthTokens!.push(UserAuthToken.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AuthResult {
        data = typeof data === 'object' ? data : {};
        let result = new AuthResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profile"] = this.profile ? this.profile.toJSON() : <any>undefined;
        data["token"] = this.token;
        if (Array.isArray(this.userAuthTokens)) {
            data["userAuthTokens"] = [];
            for (let item of this.userAuthTokens)
                data["userAuthTokens"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IAuthResult {
    profile: LinkedExpert;
    token: string;
    userAuthTokens?: UserAuthToken[] | undefined;
}

export class ChangePassword implements IChangePassword {
    captcha?: string | undefined;
    /** Старый пароль */
    oldPassword!: string;
    /** Новый пароль */
    newPassword!: string;

    constructor(data?: IChangePassword) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.captcha = _data["captcha"];
            this.oldPassword = _data["oldPassword"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ChangePassword {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePassword();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["captcha"] = this.captcha;
        data["oldPassword"] = this.oldPassword;
        data["newPassword"] = this.newPassword;
        return data; 
    }
}

export interface IChangePassword {
    captcha?: string | undefined;
    /** Старый пароль */
    oldPassword: string;
    /** Новый пароль */
    newPassword: string;
}

export class CheckAccountConfirmationToken implements ICheckAccountConfirmationToken {
    captcha?: string | undefined;
    token!: string;

    constructor(data?: ICheckAccountConfirmationToken) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.captcha = _data["captcha"];
            this.token = _data["token"];
        }
    }

    static fromJS(data: any): CheckAccountConfirmationToken {
        data = typeof data === 'object' ? data : {};
        let result = new CheckAccountConfirmationToken();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["captcha"] = this.captcha;
        data["token"] = this.token;
        return data; 
    }
}

export interface ICheckAccountConfirmationToken {
    captcha?: string | undefined;
    token: string;
}

export class CheckVerificationCode implements ICheckVerificationCode {
    captcha?: string | undefined;
    phone!: string;
    verificationCode!: string;

    constructor(data?: ICheckVerificationCode) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.captcha = _data["captcha"];
            this.phone = _data["phone"];
            this.verificationCode = _data["verificationCode"];
        }
    }

    static fromJS(data: any): CheckVerificationCode {
        data = typeof data === 'object' ? data : {};
        let result = new CheckVerificationCode();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["captcha"] = this.captcha;
        data["phone"] = this.phone;
        data["verificationCode"] = this.verificationCode;
        return data; 
    }
}

export interface ICheckVerificationCode {
    captcha?: string | undefined;
    phone: string;
    verificationCode: string;
}

export enum CitizenshipType {
    Russian = "russian",
    RussianWithOther = "russianWithOther",
    Foreigner = "foreigner",
    WithoutCitizenship = "withoutCitizenship",
}

export class ConfirmAccount implements IConfirmAccount {
    captcha?: string | undefined;
    token!: string;
    password!: string;
    /** Дата рождения, время должно быть 00ч. 00м. 00с. по UTC */
    birthDate!: moment.Moment;
    sex!: Sex;
    verificationCode!: string;

    constructor(data?: IConfirmAccount) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.captcha = _data["captcha"];
            this.token = _data["token"];
            this.password = _data["password"];
            this.birthDate = _data["birthDate"] ? moment(_data["birthDate"].toString()) : <any>undefined;
            this.sex = _data["sex"];
            this.verificationCode = _data["verificationCode"];
        }
    }

    static fromJS(data: any): ConfirmAccount {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmAccount();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["captcha"] = this.captcha;
        data["token"] = this.token;
        data["password"] = this.password;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["sex"] = this.sex;
        data["verificationCode"] = this.verificationCode;
        return data; 
    }
}

export interface IConfirmAccount {
    captcha?: string | undefined;
    token: string;
    password: string;
    /** Дата рождения, время должно быть 00ч. 00м. 00с. по UTC */
    birthDate: moment.Moment;
    sex: Sex;
    verificationCode: string;
}

export class ConfirmEmailByToken implements IConfirmEmailByToken {
    captcha?: string | undefined;
    token!: string;

    constructor(data?: IConfirmEmailByToken) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.captcha = _data["captcha"];
            this.token = _data["token"];
        }
    }

    static fromJS(data: any): ConfirmEmailByToken {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmEmailByToken();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["captcha"] = this.captcha;
        data["token"] = this.token;
        return data; 
    }
}

export interface IConfirmEmailByToken {
    captcha?: string | undefined;
    token: string;
}

export enum DiplomaType {
    Specialist = "specialist",
    Bachelor = "bachelor",
    Spo = "spo",
    Residency = "residency",
    Pp = "pp",
    ExtractFromProtocolGIA = "extractFromProtocolGIA",
}

export enum DocumentType {
    Other = "other",
    IdentityDoc = "identityDoc",
    SecondaryEducationConfirmation = "secondaryEducationConfirmation",
    HigherEducationConfirmation = "higherEducationConfirmation",
    WorkExperienceConfirmation = "workExperienceConfirmation",
    ContinuingEducationConfirmation = "continuingEducationConfirmation",
    Snils = "snils",
    NoCriminalRecord = "noCriminalRecord",
    QualificationCertificate = "qualificationCertificate",
    ConsentToProcessingPersonalData = "consentToProcessingPersonalData",
}

export class EventsStateHolder implements IEventsStateHolder {
    eventsState?: { [key: string]: number; } | undefined;

    constructor(data?: IEventsStateHolder) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["eventsState"]) {
                this.eventsState = {} as any;
                for (let key in _data["eventsState"]) {
                    if (_data["eventsState"].hasOwnProperty(key))
                        (<any>this.eventsState)![key] = _data["eventsState"][key];
                }
            }
        }
    }

    static fromJS(data: any): EventsStateHolder {
        data = typeof data === 'object' ? data : {};
        let result = new EventsStateHolder();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.eventsState) {
            data["eventsState"] = {};
            for (let key in this.eventsState) {
                if (this.eventsState.hasOwnProperty(key))
                    (<any>data["eventsState"])[key] = this.eventsState[key];
            }
        }
        return data; 
    }
}

export interface IEventsStateHolder {
    eventsState?: { [key: string]: number; } | undefined;
}

export class Exam implements IExam {
    id!: string;
    date!: moment.Moment;
    lastDate!: moment.Moment;
    qualificationId!: string;
    attestationSubCommissionId!: string;
    qualificationTitle!: string;
    qualificationResidency!: boolean;
    stagesNumber!: number;
    accreditationCenterName!: string;
    attestationCommissionName!: string;
    attestationSubCommissionName!: string;
    address!: string;
    city!: string;
    region!: string;
    status!: ExamStatus;
    statusChangeTime!: moment.Moment;
    attestationCommissionId!: string;
    /** Количество аккредитуемых */
    applicationsNumber!: number;
    /** Номер текущего этапа */
    currentStageNumber?: number | undefined;
    /** Дата проведения первого дня текущего этапа */
    currentStageFirstDayDate?: moment.Moment | undefined;
    /** Дата проведения последнего дня текущего этапа */
    currentStageLastDayDate?: moment.Moment | undefined;
    /** Номер пересдачи если она была, показывать в случае больше нуля */
    currentStageAttemptNumber?: number | undefined;

    constructor(data?: IExam) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>undefined;
            this.lastDate = _data["lastDate"] ? moment(_data["lastDate"].toString()) : <any>undefined;
            this.qualificationId = _data["qualificationId"];
            this.attestationSubCommissionId = _data["attestationSubCommissionId"];
            this.qualificationTitle = _data["qualificationTitle"];
            this.qualificationResidency = _data["qualificationResidency"];
            this.stagesNumber = _data["stagesNumber"];
            this.accreditationCenterName = _data["accreditationCenterName"];
            this.attestationCommissionName = _data["attestationCommissionName"];
            this.attestationSubCommissionName = _data["attestationSubCommissionName"];
            this.address = _data["address"];
            this.city = _data["city"];
            this.region = _data["region"];
            this.status = _data["status"];
            this.statusChangeTime = _data["statusChangeTime"] ? moment(_data["statusChangeTime"].toString()) : <any>undefined;
            this.attestationCommissionId = _data["attestationCommissionId"];
            this.applicationsNumber = _data["applicationsNumber"];
            this.currentStageNumber = _data["currentStageNumber"];
            this.currentStageFirstDayDate = _data["currentStageFirstDayDate"] ? moment(_data["currentStageFirstDayDate"].toString()) : <any>undefined;
            this.currentStageLastDayDate = _data["currentStageLastDayDate"] ? moment(_data["currentStageLastDayDate"].toString()) : <any>undefined;
            this.currentStageAttemptNumber = _data["currentStageAttemptNumber"];
        }
    }

    static fromJS(data: any): Exam {
        data = typeof data === 'object' ? data : {};
        let result = new Exam();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["lastDate"] = this.lastDate ? this.lastDate.toISOString() : <any>undefined;
        data["qualificationId"] = this.qualificationId;
        data["attestationSubCommissionId"] = this.attestationSubCommissionId;
        data["qualificationTitle"] = this.qualificationTitle;
        data["qualificationResidency"] = this.qualificationResidency;
        data["stagesNumber"] = this.stagesNumber;
        data["accreditationCenterName"] = this.accreditationCenterName;
        data["attestationCommissionName"] = this.attestationCommissionName;
        data["attestationSubCommissionName"] = this.attestationSubCommissionName;
        data["address"] = this.address;
        data["city"] = this.city;
        data["region"] = this.region;
        data["status"] = this.status;
        data["statusChangeTime"] = this.statusChangeTime ? this.statusChangeTime.toISOString() : <any>undefined;
        data["attestationCommissionId"] = this.attestationCommissionId;
        data["applicationsNumber"] = this.applicationsNumber;
        data["currentStageNumber"] = this.currentStageNumber;
        data["currentStageFirstDayDate"] = this.currentStageFirstDayDate ? this.currentStageFirstDayDate.toISOString() : <any>undefined;
        data["currentStageLastDayDate"] = this.currentStageLastDayDate ? this.currentStageLastDayDate.toISOString() : <any>undefined;
        data["currentStageAttemptNumber"] = this.currentStageAttemptNumber;
        return data; 
    }
}

export interface IExam {
    id: string;
    date: moment.Moment;
    lastDate: moment.Moment;
    qualificationId: string;
    attestationSubCommissionId: string;
    qualificationTitle: string;
    qualificationResidency: boolean;
    stagesNumber: number;
    accreditationCenterName: string;
    attestationCommissionName: string;
    attestationSubCommissionName: string;
    address: string;
    city: string;
    region: string;
    status: ExamStatus;
    statusChangeTime: moment.Moment;
    attestationCommissionId: string;
    /** Количество аккредитуемых */
    applicationsNumber: number;
    /** Номер текущего этапа */
    currentStageNumber?: number | undefined;
    /** Дата проведения первого дня текущего этапа */
    currentStageFirstDayDate?: moment.Moment | undefined;
    /** Дата проведения последнего дня текущего этапа */
    currentStageLastDayDate?: moment.Moment | undefined;
    /** Номер пересдачи если она была, показывать в случае больше нуля */
    currentStageAttemptNumber?: number | undefined;
}

export class ExamApplication implements IExamApplication {
    status!: ExamApplicationStatus;
    finalized!: boolean;
    statusChangeTime!: moment.Moment;
    examApplicationId!: string;
    applicationSubmitDate!: moment.Moment;
    lastFinalizedStage?: number | undefined;
    lastFinalizedStageResult!: FinalizedResult;
    lastFinalizedStageAttemptNumber!: number;
    applicantId!: string;
    applicantFullName!: string;
    applicantPhone!: string;
    applicantEmail!: string;
    birthDate!: moment.Moment;
    applicantSnils!: string;

    constructor(data?: IExamApplication) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.finalized = _data["finalized"];
            this.statusChangeTime = _data["statusChangeTime"] ? moment(_data["statusChangeTime"].toString()) : <any>undefined;
            this.examApplicationId = _data["examApplicationId"];
            this.applicationSubmitDate = _data["applicationSubmitDate"] ? moment(_data["applicationSubmitDate"].toString()) : <any>undefined;
            this.lastFinalizedStage = _data["lastFinalizedStage"];
            this.lastFinalizedStageResult = _data["lastFinalizedStageResult"];
            this.lastFinalizedStageAttemptNumber = _data["lastFinalizedStageAttemptNumber"];
            this.applicantId = _data["applicantId"];
            this.applicantFullName = _data["applicantFullName"];
            this.applicantPhone = _data["applicantPhone"];
            this.applicantEmail = _data["applicantEmail"];
            this.birthDate = _data["birthDate"] ? moment(_data["birthDate"].toString()) : <any>undefined;
            this.applicantSnils = _data["applicantSnils"];
        }
    }

    static fromJS(data: any): ExamApplication {
        data = typeof data === 'object' ? data : {};
        let result = new ExamApplication();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["finalized"] = this.finalized;
        data["statusChangeTime"] = this.statusChangeTime ? this.statusChangeTime.toISOString() : <any>undefined;
        data["examApplicationId"] = this.examApplicationId;
        data["applicationSubmitDate"] = this.applicationSubmitDate ? this.applicationSubmitDate.toISOString() : <any>undefined;
        data["lastFinalizedStage"] = this.lastFinalizedStage;
        data["lastFinalizedStageResult"] = this.lastFinalizedStageResult;
        data["lastFinalizedStageAttemptNumber"] = this.lastFinalizedStageAttemptNumber;
        data["applicantId"] = this.applicantId;
        data["applicantFullName"] = this.applicantFullName;
        data["applicantPhone"] = this.applicantPhone;
        data["applicantEmail"] = this.applicantEmail;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["applicantSnils"] = this.applicantSnils;
        return data; 
    }
}

export interface IExamApplication {
    status: ExamApplicationStatus;
    finalized: boolean;
    statusChangeTime: moment.Moment;
    examApplicationId: string;
    applicationSubmitDate: moment.Moment;
    lastFinalizedStage?: number | undefined;
    lastFinalizedStageResult: FinalizedResult;
    lastFinalizedStageAttemptNumber: number;
    applicantId: string;
    applicantFullName: string;
    applicantPhone: string;
    applicantEmail: string;
    birthDate: moment.Moment;
    applicantSnils: string;
}

export class ExamApplicationDetails implements IExamApplicationDetails {
    status!: ExamApplicationStatus;
    finalized!: boolean;
    statusChangeTime!: moment.Moment;
    examApplicationId!: string;
    applicationSubmitDate!: moment.Moment;
    lastFinalizedStage?: number | undefined;
    lastFinalizedStageResult!: FinalizedResult;
    lastFinalizedStageAttemptNumber!: number;
    exam!: Exam;
    applicant!: Applicant;
    applicantIdentityDoc!: ApplicantIdentityDoc;
    applicantDiploma?: ApplicantDiploma;
    documents!: ExamApplicationDocument[];
    reviewComment?: string | undefined;
    /** Профессиональная переподготовка, возможна только в случае ординатуры */
    professionalRetraining?: boolean | undefined;
    /** Запрос на допуск к аккредитации начиная с n-го этапа */
    startStage?: number | undefined;
    signCode?: string | undefined;
    approveCode?: string | undefined;
    examDayApplications!: ExamDayApplicationShort[];
    eventsState?: { [key: string]: number; } | undefined;

    constructor(data?: IExamApplicationDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.exam = new Exam();
            this.applicant = new Applicant();
            this.applicantIdentityDoc = new ApplicantIdentityDoc();
            this.documents = [];
            this.examDayApplications = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.finalized = _data["finalized"];
            this.statusChangeTime = _data["statusChangeTime"] ? moment(_data["statusChangeTime"].toString()) : <any>undefined;
            this.examApplicationId = _data["examApplicationId"];
            this.applicationSubmitDate = _data["applicationSubmitDate"] ? moment(_data["applicationSubmitDate"].toString()) : <any>undefined;
            this.lastFinalizedStage = _data["lastFinalizedStage"];
            this.lastFinalizedStageResult = _data["lastFinalizedStageResult"];
            this.lastFinalizedStageAttemptNumber = _data["lastFinalizedStageAttemptNumber"];
            this.exam = _data["exam"] ? Exam.fromJS(_data["exam"]) : new Exam();
            this.applicant = _data["applicant"] ? Applicant.fromJS(_data["applicant"]) : new Applicant();
            this.applicantIdentityDoc = _data["applicantIdentityDoc"] ? ApplicantIdentityDoc.fromJS(_data["applicantIdentityDoc"]) : new ApplicantIdentityDoc();
            this.applicantDiploma = _data["applicantDiploma"] ? ApplicantDiploma.fromJS(_data["applicantDiploma"]) : <any>undefined;
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(ExamApplicationDocument.fromJS(item));
            }
            this.reviewComment = _data["reviewComment"];
            this.professionalRetraining = _data["professionalRetraining"];
            this.startStage = _data["startStage"];
            this.signCode = _data["signCode"];
            this.approveCode = _data["approveCode"];
            if (Array.isArray(_data["examDayApplications"])) {
                this.examDayApplications = [] as any;
                for (let item of _data["examDayApplications"])
                    this.examDayApplications!.push(ExamDayApplicationShort.fromJS(item));
            }
            if (_data["eventsState"]) {
                this.eventsState = {} as any;
                for (let key in _data["eventsState"]) {
                    if (_data["eventsState"].hasOwnProperty(key))
                        (<any>this.eventsState)![key] = _data["eventsState"][key];
                }
            }
        }
    }

    static fromJS(data: any): ExamApplicationDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ExamApplicationDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["finalized"] = this.finalized;
        data["statusChangeTime"] = this.statusChangeTime ? this.statusChangeTime.toISOString() : <any>undefined;
        data["examApplicationId"] = this.examApplicationId;
        data["applicationSubmitDate"] = this.applicationSubmitDate ? this.applicationSubmitDate.toISOString() : <any>undefined;
        data["lastFinalizedStage"] = this.lastFinalizedStage;
        data["lastFinalizedStageResult"] = this.lastFinalizedStageResult;
        data["lastFinalizedStageAttemptNumber"] = this.lastFinalizedStageAttemptNumber;
        data["exam"] = this.exam ? this.exam.toJSON() : <any>undefined;
        data["applicant"] = this.applicant ? this.applicant.toJSON() : <any>undefined;
        data["applicantIdentityDoc"] = this.applicantIdentityDoc ? this.applicantIdentityDoc.toJSON() : <any>undefined;
        data["applicantDiploma"] = this.applicantDiploma ? this.applicantDiploma.toJSON() : <any>undefined;
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        data["reviewComment"] = this.reviewComment;
        data["professionalRetraining"] = this.professionalRetraining;
        data["startStage"] = this.startStage;
        data["signCode"] = this.signCode;
        data["approveCode"] = this.approveCode;
        if (Array.isArray(this.examDayApplications)) {
            data["examDayApplications"] = [];
            for (let item of this.examDayApplications)
                data["examDayApplications"].push(item.toJSON());
        }
        if (this.eventsState) {
            data["eventsState"] = {};
            for (let key in this.eventsState) {
                if (this.eventsState.hasOwnProperty(key))
                    (<any>data["eventsState"])[key] = this.eventsState[key];
            }
        }
        return data; 
    }
}

export interface IExamApplicationDetails {
    status: ExamApplicationStatus;
    finalized: boolean;
    statusChangeTime: moment.Moment;
    examApplicationId: string;
    applicationSubmitDate: moment.Moment;
    lastFinalizedStage?: number | undefined;
    lastFinalizedStageResult: FinalizedResult;
    lastFinalizedStageAttemptNumber: number;
    exam: Exam;
    applicant: Applicant;
    applicantIdentityDoc: ApplicantIdentityDoc;
    applicantDiploma?: ApplicantDiploma;
    documents: ExamApplicationDocument[];
    reviewComment?: string | undefined;
    /** Профессиональная переподготовка, возможна только в случае ординатуры */
    professionalRetraining?: boolean | undefined;
    /** Запрос на допуск к аккредитации начиная с n-го этапа */
    startStage?: number | undefined;
    signCode?: string | undefined;
    approveCode?: string | undefined;
    examDayApplications: ExamDayApplicationShort[];
    eventsState?: { [key: string]: number; } | undefined;
}

export class ExamApplicationDocument implements IExamApplicationDocument {
    readonly fileId!: string;
    readonly fileExtension!: string;
    readonly fileSize!: number;
    readonly fileUrl!: string;
    id!: string;
    documentDescription!: string;
    variant!: number;
    type!: DocumentType;
    documentTemplateId?: string | undefined;
    examApplicationId!: string;
    applicantId!: string;
    submissionDate!: moment.Moment;
    readonly sourceFiles!: SourceFile[];

    constructor(data?: IExamApplicationDocument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.sourceFiles = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).fileId = _data["fileId"];
            (<any>this).fileExtension = _data["fileExtension"];
            (<any>this).fileSize = _data["fileSize"];
            (<any>this).fileUrl = _data["fileUrl"];
            this.id = _data["id"];
            this.documentDescription = _data["documentDescription"];
            this.variant = _data["variant"];
            this.type = _data["type"];
            this.documentTemplateId = _data["documentTemplateId"];
            this.examApplicationId = _data["examApplicationId"];
            this.applicantId = _data["applicantId"];
            this.submissionDate = _data["submissionDate"] ? moment(_data["submissionDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["sourceFiles"])) {
                (<any>this).sourceFiles = [] as any;
                for (let item of _data["sourceFiles"])
                    (<any>this).sourceFiles!.push(SourceFile.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ExamApplicationDocument {
        data = typeof data === 'object' ? data : {};
        let result = new ExamApplicationDocument();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileId"] = this.fileId;
        data["fileExtension"] = this.fileExtension;
        data["fileSize"] = this.fileSize;
        data["fileUrl"] = this.fileUrl;
        data["id"] = this.id;
        data["documentDescription"] = this.documentDescription;
        data["variant"] = this.variant;
        data["type"] = this.type;
        data["documentTemplateId"] = this.documentTemplateId;
        data["examApplicationId"] = this.examApplicationId;
        data["applicantId"] = this.applicantId;
        data["submissionDate"] = this.submissionDate ? this.submissionDate.toISOString() : <any>undefined;
        if (Array.isArray(this.sourceFiles)) {
            data["sourceFiles"] = [];
            for (let item of this.sourceFiles)
                data["sourceFiles"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IExamApplicationDocument {
    fileId: string;
    fileExtension: string;
    fileSize: number;
    fileUrl: string;
    id: string;
    documentDescription: string;
    variant: number;
    type: DocumentType;
    documentTemplateId?: string | undefined;
    examApplicationId: string;
    applicantId: string;
    submissionDate: moment.Moment;
    sourceFiles: SourceFile[];
}

export class ExamApplicationList implements IExamApplicationList {
    items!: ExamApplication[];
    page!: number;
    pageSize!: number;
    total!: number;
    admittedCount!: number;
    eventsState?: { [key: string]: number; } | undefined;

    constructor(data?: IExamApplicationList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ExamApplication.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.total = _data["total"];
            this.admittedCount = _data["admittedCount"];
            if (_data["eventsState"]) {
                this.eventsState = {} as any;
                for (let key in _data["eventsState"]) {
                    if (_data["eventsState"].hasOwnProperty(key))
                        (<any>this.eventsState)![key] = _data["eventsState"][key];
                }
            }
        }
    }

    static fromJS(data: any): ExamApplicationList {
        data = typeof data === 'object' ? data : {};
        let result = new ExamApplicationList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["total"] = this.total;
        data["admittedCount"] = this.admittedCount;
        if (this.eventsState) {
            data["eventsState"] = {};
            for (let key in this.eventsState) {
                if (this.eventsState.hasOwnProperty(key))
                    (<any>data["eventsState"])[key] = this.eventsState[key];
            }
        }
        return data; 
    }
}

export interface IExamApplicationList {
    items: ExamApplication[];
    page: number;
    pageSize: number;
    total: number;
    admittedCount: number;
    eventsState?: { [key: string]: number; } | undefined;
}

export enum ExamApplicationStatus {
    Draft = "draft",
    InReview = "inReview",
    CorrectionsRequired = "correctionsRequired",
    Canceled = "canceled",
    Approved = "approved",
    Staging = "staging",
    Absent = "absent",
    NotPassed = "notPassed",
    Passed = "passed",
}

export class ExamDay implements IExamDay {
    id!: string;
    examId!: string;
    stageNumber!: number;
    dayNumber!: number;
    group?: number | undefined;
    time!: moment.Moment;
    totalApplications!: number;
    unFinalizedApplications!: number;
    totalExperts!: number;
    readyForFinalize!: boolean;
    canAssignApplications!: boolean;

    constructor(data?: IExamDay) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.examId = _data["examId"];
            this.stageNumber = _data["stageNumber"];
            this.dayNumber = _data["dayNumber"];
            this.group = _data["group"];
            this.time = _data["time"] ? moment(_data["time"].toString()) : <any>undefined;
            this.totalApplications = _data["totalApplications"];
            this.unFinalizedApplications = _data["unFinalizedApplications"];
            this.totalExperts = _data["totalExperts"];
            this.readyForFinalize = _data["readyForFinalize"];
            this.canAssignApplications = _data["canAssignApplications"];
        }
    }

    static fromJS(data: any): ExamDay {
        data = typeof data === 'object' ? data : {};
        let result = new ExamDay();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["examId"] = this.examId;
        data["stageNumber"] = this.stageNumber;
        data["dayNumber"] = this.dayNumber;
        data["group"] = this.group;
        data["time"] = this.time ? this.time.toISOString() : <any>undefined;
        data["totalApplications"] = this.totalApplications;
        data["unFinalizedApplications"] = this.unFinalizedApplications;
        data["totalExperts"] = this.totalExperts;
        data["readyForFinalize"] = this.readyForFinalize;
        data["canAssignApplications"] = this.canAssignApplications;
        return data; 
    }
}

export interface IExamDay {
    id: string;
    examId: string;
    stageNumber: number;
    dayNumber: number;
    group?: number | undefined;
    time: moment.Moment;
    totalApplications: number;
    unFinalizedApplications: number;
    totalExperts: number;
    readyForFinalize: boolean;
    canAssignApplications: boolean;
}

export class ExamDayApplication implements IExamDayApplication {
    examId!: string;
    examApplicationId!: string;
    examDayId!: string;
    stageNumber!: number;
    attemptNumber!: number;
    finalizedResult!: FinalizedResult;
    examApplication!: ExamApplication;
    admitted!: boolean;
    canFinalize!: boolean;

    constructor(data?: IExamDayApplication) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.examApplication = new ExamApplication();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.examId = _data["examId"];
            this.examApplicationId = _data["examApplicationId"];
            this.examDayId = _data["examDayId"];
            this.stageNumber = _data["stageNumber"];
            this.attemptNumber = _data["attemptNumber"];
            this.finalizedResult = _data["finalizedResult"];
            this.examApplication = _data["examApplication"] ? ExamApplication.fromJS(_data["examApplication"]) : new ExamApplication();
            this.admitted = _data["admitted"];
            this.canFinalize = _data["canFinalize"];
        }
    }

    static fromJS(data: any): ExamDayApplication {
        data = typeof data === 'object' ? data : {};
        let result = new ExamDayApplication();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["examId"] = this.examId;
        data["examApplicationId"] = this.examApplicationId;
        data["examDayId"] = this.examDayId;
        data["stageNumber"] = this.stageNumber;
        data["attemptNumber"] = this.attemptNumber;
        data["finalizedResult"] = this.finalizedResult;
        data["examApplication"] = this.examApplication ? this.examApplication.toJSON() : <any>undefined;
        data["admitted"] = this.admitted;
        data["canFinalize"] = this.canFinalize;
        return data; 
    }
}

export interface IExamDayApplication {
    examId: string;
    examApplicationId: string;
    examDayId: string;
    stageNumber: number;
    attemptNumber: number;
    finalizedResult: FinalizedResult;
    examApplication: ExamApplication;
    admitted: boolean;
    canFinalize: boolean;
}

export class ExamDayApplications implements IExamDayApplications {
    items!: ExamDayApplication[];
    page!: number;
    pageSize!: number;
    total!: number;

    constructor(data?: IExamDayApplications) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ExamDayApplication.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.total = _data["total"];
        }
    }

    static fromJS(data: any): ExamDayApplications {
        data = typeof data === 'object' ? data : {};
        let result = new ExamDayApplications();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["total"] = this.total;
        return data; 
    }
}

export interface IExamDayApplications {
    items: ExamDayApplication[];
    page: number;
    pageSize: number;
    total: number;
}

export class ExamDayApplicationShort implements IExamDayApplicationShort {
    examDayId!: string;
    stageNumber!: number;
    attemptNumber!: number;
    admitted!: boolean;
    finalizedResult!: FinalizedResult;
    examDayDateTime!: moment.Moment;

    constructor(data?: IExamDayApplicationShort) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.examDayId = _data["examDayId"];
            this.stageNumber = _data["stageNumber"];
            this.attemptNumber = _data["attemptNumber"];
            this.admitted = _data["admitted"];
            this.finalizedResult = _data["finalizedResult"];
            this.examDayDateTime = _data["examDayDateTime"] ? moment(_data["examDayDateTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ExamDayApplicationShort {
        data = typeof data === 'object' ? data : {};
        let result = new ExamDayApplicationShort();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["examDayId"] = this.examDayId;
        data["stageNumber"] = this.stageNumber;
        data["attemptNumber"] = this.attemptNumber;
        data["admitted"] = this.admitted;
        data["finalizedResult"] = this.finalizedResult;
        data["examDayDateTime"] = this.examDayDateTime ? this.examDayDateTime.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IExamDayApplicationShort {
    examDayId: string;
    stageNumber: number;
    attemptNumber: number;
    admitted: boolean;
    finalizedResult: FinalizedResult;
    examDayDateTime: moment.Moment;
}

export class ExamDetails implements IExamDetails {
    id!: string;
    date!: moment.Moment;
    lastDate!: moment.Moment;
    qualificationId!: string;
    attestationSubCommissionId!: string;
    qualificationTitle!: string;
    qualificationResidency!: boolean;
    stagesNumber!: number;
    accreditationCenterName!: string;
    attestationCommissionName!: string;
    attestationSubCommissionName!: string;
    address!: string;
    city!: string;
    region!: string;
    status!: ExamStatus;
    statusChangeTime!: moment.Moment;
    attestationCommissionId!: string;
    /** Количество аккредитуемых */
    applicationsNumber!: number;
    /** Номер текущего этапа */
    currentStageNumber?: number | undefined;
    /** Дата проведения первого дня текущего этапа */
    currentStageFirstDayDate?: moment.Moment | undefined;
    /** Дата проведения последнего дня текущего этапа */
    currentStageLastDayDate?: moment.Moment | undefined;
    /** Номер пересдачи если она была, показывать в случае больше нуля */
    currentStageAttemptNumber?: number | undefined;
    examLogs!: ExamLog[];
    examStages!: ExamStage[];
    rules?: string | undefined;
    /** Минимально необходимое количество членов комиссии */
    minimumRequiredExpertsNumber!: number;
    applyingDeadline!: moment.Moment;
    regionName!: string;
    secretaryFullName!: string;
    secretaryPhone!: string;
    examCreationProgress!: ApprovalProcessStep[];
    eventsState?: { [key: string]: number; } | undefined;

    constructor(data?: IExamDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.examLogs = [];
            this.examStages = [];
            this.examCreationProgress = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>undefined;
            this.lastDate = _data["lastDate"] ? moment(_data["lastDate"].toString()) : <any>undefined;
            this.qualificationId = _data["qualificationId"];
            this.attestationSubCommissionId = _data["attestationSubCommissionId"];
            this.qualificationTitle = _data["qualificationTitle"];
            this.qualificationResidency = _data["qualificationResidency"];
            this.stagesNumber = _data["stagesNumber"];
            this.accreditationCenterName = _data["accreditationCenterName"];
            this.attestationCommissionName = _data["attestationCommissionName"];
            this.attestationSubCommissionName = _data["attestationSubCommissionName"];
            this.address = _data["address"];
            this.city = _data["city"];
            this.region = _data["region"];
            this.status = _data["status"];
            this.statusChangeTime = _data["statusChangeTime"] ? moment(_data["statusChangeTime"].toString()) : <any>undefined;
            this.attestationCommissionId = _data["attestationCommissionId"];
            this.applicationsNumber = _data["applicationsNumber"];
            this.currentStageNumber = _data["currentStageNumber"];
            this.currentStageFirstDayDate = _data["currentStageFirstDayDate"] ? moment(_data["currentStageFirstDayDate"].toString()) : <any>undefined;
            this.currentStageLastDayDate = _data["currentStageLastDayDate"] ? moment(_data["currentStageLastDayDate"].toString()) : <any>undefined;
            this.currentStageAttemptNumber = _data["currentStageAttemptNumber"];
            if (Array.isArray(_data["examLogs"])) {
                this.examLogs = [] as any;
                for (let item of _data["examLogs"])
                    this.examLogs!.push(ExamLog.fromJS(item));
            }
            if (Array.isArray(_data["examStages"])) {
                this.examStages = [] as any;
                for (let item of _data["examStages"])
                    this.examStages!.push(ExamStage.fromJS(item));
            }
            this.rules = _data["rules"];
            this.minimumRequiredExpertsNumber = _data["minimumRequiredExpertsNumber"];
            this.applyingDeadline = _data["applyingDeadline"] ? moment(_data["applyingDeadline"].toString()) : <any>undefined;
            this.regionName = _data["regionName"];
            this.secretaryFullName = _data["secretaryFullName"];
            this.secretaryPhone = _data["secretaryPhone"];
            if (Array.isArray(_data["examCreationProgress"])) {
                this.examCreationProgress = [] as any;
                for (let item of _data["examCreationProgress"])
                    this.examCreationProgress!.push(ApprovalProcessStep.fromJS(item));
            }
            if (_data["eventsState"]) {
                this.eventsState = {} as any;
                for (let key in _data["eventsState"]) {
                    if (_data["eventsState"].hasOwnProperty(key))
                        (<any>this.eventsState)![key] = _data["eventsState"][key];
                }
            }
        }
    }

    static fromJS(data: any): ExamDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ExamDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["lastDate"] = this.lastDate ? this.lastDate.toISOString() : <any>undefined;
        data["qualificationId"] = this.qualificationId;
        data["attestationSubCommissionId"] = this.attestationSubCommissionId;
        data["qualificationTitle"] = this.qualificationTitle;
        data["qualificationResidency"] = this.qualificationResidency;
        data["stagesNumber"] = this.stagesNumber;
        data["accreditationCenterName"] = this.accreditationCenterName;
        data["attestationCommissionName"] = this.attestationCommissionName;
        data["attestationSubCommissionName"] = this.attestationSubCommissionName;
        data["address"] = this.address;
        data["city"] = this.city;
        data["region"] = this.region;
        data["status"] = this.status;
        data["statusChangeTime"] = this.statusChangeTime ? this.statusChangeTime.toISOString() : <any>undefined;
        data["attestationCommissionId"] = this.attestationCommissionId;
        data["applicationsNumber"] = this.applicationsNumber;
        data["currentStageNumber"] = this.currentStageNumber;
        data["currentStageFirstDayDate"] = this.currentStageFirstDayDate ? this.currentStageFirstDayDate.toISOString() : <any>undefined;
        data["currentStageLastDayDate"] = this.currentStageLastDayDate ? this.currentStageLastDayDate.toISOString() : <any>undefined;
        data["currentStageAttemptNumber"] = this.currentStageAttemptNumber;
        if (Array.isArray(this.examLogs)) {
            data["examLogs"] = [];
            for (let item of this.examLogs)
                data["examLogs"].push(item.toJSON());
        }
        if (Array.isArray(this.examStages)) {
            data["examStages"] = [];
            for (let item of this.examStages)
                data["examStages"].push(item.toJSON());
        }
        data["rules"] = this.rules;
        data["minimumRequiredExpertsNumber"] = this.minimumRequiredExpertsNumber;
        data["applyingDeadline"] = this.applyingDeadline ? this.applyingDeadline.toISOString() : <any>undefined;
        data["regionName"] = this.regionName;
        data["secretaryFullName"] = this.secretaryFullName;
        data["secretaryPhone"] = this.secretaryPhone;
        if (Array.isArray(this.examCreationProgress)) {
            data["examCreationProgress"] = [];
            for (let item of this.examCreationProgress)
                data["examCreationProgress"].push(item.toJSON());
        }
        if (this.eventsState) {
            data["eventsState"] = {};
            for (let key in this.eventsState) {
                if (this.eventsState.hasOwnProperty(key))
                    (<any>data["eventsState"])[key] = this.eventsState[key];
            }
        }
        return data; 
    }
}

export interface IExamDetails {
    id: string;
    date: moment.Moment;
    lastDate: moment.Moment;
    qualificationId: string;
    attestationSubCommissionId: string;
    qualificationTitle: string;
    qualificationResidency: boolean;
    stagesNumber: number;
    accreditationCenterName: string;
    attestationCommissionName: string;
    attestationSubCommissionName: string;
    address: string;
    city: string;
    region: string;
    status: ExamStatus;
    statusChangeTime: moment.Moment;
    attestationCommissionId: string;
    /** Количество аккредитуемых */
    applicationsNumber: number;
    /** Номер текущего этапа */
    currentStageNumber?: number | undefined;
    /** Дата проведения первого дня текущего этапа */
    currentStageFirstDayDate?: moment.Moment | undefined;
    /** Дата проведения последнего дня текущего этапа */
    currentStageLastDayDate?: moment.Moment | undefined;
    /** Номер пересдачи если она была, показывать в случае больше нуля */
    currentStageAttemptNumber?: number | undefined;
    examLogs: ExamLog[];
    examStages: ExamStage[];
    rules?: string | undefined;
    /** Минимально необходимое количество членов комиссии */
    minimumRequiredExpertsNumber: number;
    applyingDeadline: moment.Moment;
    regionName: string;
    secretaryFullName: string;
    secretaryPhone: string;
    examCreationProgress: ApprovalProcessStep[];
    eventsState?: { [key: string]: number; } | undefined;
}

export class ExamList implements IExamList {
    items!: Exam[];
    page!: number;
    pageSize!: number;
    total!: number;
    eventsState?: { [key: string]: number; } | undefined;

    constructor(data?: IExamList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(Exam.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.total = _data["total"];
            if (_data["eventsState"]) {
                this.eventsState = {} as any;
                for (let key in _data["eventsState"]) {
                    if (_data["eventsState"].hasOwnProperty(key))
                        (<any>this.eventsState)![key] = _data["eventsState"][key];
                }
            }
        }
    }

    static fromJS(data: any): ExamList {
        data = typeof data === 'object' ? data : {};
        let result = new ExamList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["total"] = this.total;
        if (this.eventsState) {
            data["eventsState"] = {};
            for (let key in this.eventsState) {
                if (this.eventsState.hasOwnProperty(key))
                    (<any>data["eventsState"])[key] = this.eventsState[key];
            }
        }
        return data; 
    }
}

export interface IExamList {
    items: Exam[];
    page: number;
    pageSize: number;
    total: number;
    eventsState?: { [key: string]: number; } | undefined;
}

export class ExamLog implements IExamLog {
    statusText!: string;
    time!: moment.Moment;

    constructor(data?: IExamLog) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusText = _data["statusText"];
            this.time = _data["time"] ? moment(_data["time"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ExamLog {
        data = typeof data === 'object' ? data : {};
        let result = new ExamLog();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusText"] = this.statusText;
        data["time"] = this.time ? this.time.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IExamLog {
    statusText: string;
    time: moment.Moment;
}

export class ExamStage implements IExamStage {
    examId!: string;
    stageNumber!: number;
    accreditationCenterId!: string;
    status!: ExamStageStatus;
    examDays!: ExamDay[];
    totalApplications!: number;
    unassignedApplications!: number;
    firstDayDateTime!: moment.Moment;
    lastDayDateTime?: moment.Moment | undefined;
    readyForAssign!: boolean;
    /** Вместительность аудитории АЦ */
    audienceCapacity!: number;
    accreditationCenterName!: string;
    secretaryPhone?: string | undefined;
    secretaryEmail?: string | undefined;
    secretaryFullName?: string | undefined;

    constructor(data?: IExamStage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.examDays = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.examId = _data["examId"];
            this.stageNumber = _data["stageNumber"];
            this.accreditationCenterId = _data["accreditationCenterId"];
            this.status = _data["status"];
            if (Array.isArray(_data["examDays"])) {
                this.examDays = [] as any;
                for (let item of _data["examDays"])
                    this.examDays!.push(ExamDay.fromJS(item));
            }
            this.totalApplications = _data["totalApplications"];
            this.unassignedApplications = _data["unassignedApplications"];
            this.firstDayDateTime = _data["firstDayDateTime"] ? moment(_data["firstDayDateTime"].toString()) : <any>undefined;
            this.lastDayDateTime = _data["lastDayDateTime"] ? moment(_data["lastDayDateTime"].toString()) : <any>undefined;
            this.readyForAssign = _data["readyForAssign"];
            this.audienceCapacity = _data["audienceCapacity"];
            this.accreditationCenterName = _data["accreditationCenterName"];
            this.secretaryPhone = _data["secretaryPhone"];
            this.secretaryEmail = _data["secretaryEmail"];
            this.secretaryFullName = _data["secretaryFullName"];
        }
    }

    static fromJS(data: any): ExamStage {
        data = typeof data === 'object' ? data : {};
        let result = new ExamStage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["examId"] = this.examId;
        data["stageNumber"] = this.stageNumber;
        data["accreditationCenterId"] = this.accreditationCenterId;
        data["status"] = this.status;
        if (Array.isArray(this.examDays)) {
            data["examDays"] = [];
            for (let item of this.examDays)
                data["examDays"].push(item.toJSON());
        }
        data["totalApplications"] = this.totalApplications;
        data["unassignedApplications"] = this.unassignedApplications;
        data["firstDayDateTime"] = this.firstDayDateTime ? this.firstDayDateTime.toISOString() : <any>undefined;
        data["lastDayDateTime"] = this.lastDayDateTime ? this.lastDayDateTime.toISOString() : <any>undefined;
        data["readyForAssign"] = this.readyForAssign;
        data["audienceCapacity"] = this.audienceCapacity;
        data["accreditationCenterName"] = this.accreditationCenterName;
        data["secretaryPhone"] = this.secretaryPhone;
        data["secretaryEmail"] = this.secretaryEmail;
        data["secretaryFullName"] = this.secretaryFullName;
        return data; 
    }
}

export interface IExamStage {
    examId: string;
    stageNumber: number;
    accreditationCenterId: string;
    status: ExamStageStatus;
    examDays: ExamDay[];
    totalApplications: number;
    unassignedApplications: number;
    firstDayDateTime: moment.Moment;
    lastDayDateTime?: moment.Moment | undefined;
    readyForAssign: boolean;
    /** Вместительность аудитории АЦ */
    audienceCapacity: number;
    accreditationCenterName: string;
    secretaryPhone?: string | undefined;
    secretaryEmail?: string | undefined;
    secretaryFullName?: string | undefined;
}

export enum ExamStageStatus {
    Assignment = "assignment",
    Finished = "finished",
}

export enum ExamStatus {
    AwaitingExpertConfirmation = "awaitingExpertConfirmation",
    IsApplying = "isApplying",
    ApplyingFinished = "applyingFinished",
    Canceled = "canceled",
    Staging = "staging",
    Finishing = "finishing",
    Finished = "finished",
}

export class Expert implements IExpert {
    id!: string;
    firstName!: string;
    lastName!: string;
    middleName!: string;
    birthDate!: moment.Moment;
    sex!: Sex;
    phone!: string;
    email!: string;
    regionId!: number;
    region!: string;
    readonly timeZoneOffset!: number;
    linkedExpertStatuses!: LinkedExpertStatus[];
    emailConfirmed!: boolean;
    registrationCompleted!: boolean;
    position!: string;
    /** Место работы */
    placeOfWork!: string;
    /** СНИЛС */
    snils!: string;

    constructor(data?: IExpert) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.linkedExpertStatuses = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.middleName = _data["middleName"];
            this.birthDate = _data["birthDate"] ? moment(_data["birthDate"].toString()) : <any>undefined;
            this.sex = _data["sex"];
            this.phone = _data["phone"];
            this.email = _data["email"];
            this.regionId = _data["regionId"];
            this.region = _data["region"];
            (<any>this).timeZoneOffset = _data["timeZoneOffset"];
            if (Array.isArray(_data["linkedExpertStatuses"])) {
                this.linkedExpertStatuses = [] as any;
                for (let item of _data["linkedExpertStatuses"])
                    this.linkedExpertStatuses!.push(LinkedExpertStatus.fromJS(item));
            }
            this.emailConfirmed = _data["emailConfirmed"];
            this.registrationCompleted = _data["registrationCompleted"];
            this.position = _data["position"];
            this.placeOfWork = _data["placeOfWork"];
            this.snils = _data["snils"];
        }
    }

    static fromJS(data: any): Expert {
        data = typeof data === 'object' ? data : {};
        let result = new Expert();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["middleName"] = this.middleName;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["sex"] = this.sex;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["regionId"] = this.regionId;
        data["region"] = this.region;
        data["timeZoneOffset"] = this.timeZoneOffset;
        if (Array.isArray(this.linkedExpertStatuses)) {
            data["linkedExpertStatuses"] = [];
            for (let item of this.linkedExpertStatuses)
                data["linkedExpertStatuses"].push(item.toJSON());
        }
        data["emailConfirmed"] = this.emailConfirmed;
        data["registrationCompleted"] = this.registrationCompleted;
        data["position"] = this.position;
        data["placeOfWork"] = this.placeOfWork;
        data["snils"] = this.snils;
        return data; 
    }
}

export interface IExpert {
    id: string;
    firstName: string;
    lastName: string;
    middleName: string;
    birthDate: moment.Moment;
    sex: Sex;
    phone: string;
    email: string;
    regionId: number;
    region: string;
    timeZoneOffset: number;
    linkedExpertStatuses: LinkedExpertStatus[];
    emailConfirmed: boolean;
    registrationCompleted: boolean;
    position: string;
    /** Место работы */
    placeOfWork: string;
    /** СНИЛС */
    snils: string;
}

export class ExpertCertificate implements IExpertCertificate {
    readonly fileId!: string;
    readonly fileExtension!: string;
    readonly fileSize!: number;
    readonly fileUrl!: string;
    id!: string;
    /** Регистрационный номер */
    regNumber!: string;
    /** Дата выдачи */
    issueDate!: moment.Moment;
    /** Дата окончания действия */
    expireDate!: moment.Moment;

    constructor(data?: IExpertCertificate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).fileId = _data["fileId"];
            (<any>this).fileExtension = _data["fileExtension"];
            (<any>this).fileSize = _data["fileSize"];
            (<any>this).fileUrl = _data["fileUrl"];
            this.id = _data["id"];
            this.regNumber = _data["regNumber"];
            this.issueDate = _data["issueDate"] ? moment(_data["issueDate"].toString()) : <any>undefined;
            this.expireDate = _data["expireDate"] ? moment(_data["expireDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ExpertCertificate {
        data = typeof data === 'object' ? data : {};
        let result = new ExpertCertificate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileId"] = this.fileId;
        data["fileExtension"] = this.fileExtension;
        data["fileSize"] = this.fileSize;
        data["fileUrl"] = this.fileUrl;
        data["id"] = this.id;
        data["regNumber"] = this.regNumber;
        data["issueDate"] = this.issueDate ? this.issueDate.toISOString() : <any>undefined;
        data["expireDate"] = this.expireDate ? this.expireDate.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IExpertCertificate {
    fileId: string;
    fileExtension: string;
    fileSize: number;
    fileUrl: string;
    id: string;
    /** Регистрационный номер */
    regNumber: string;
    /** Дата выдачи */
    issueDate: moment.Moment;
    /** Дата окончания действия */
    expireDate: moment.Moment;
}

export class ExpertChangeRequest implements IExpertChangeRequest {
    id!: string;
    dateTime!: moment.Moment;
    expertId!: string;
    expertChangeRequestsOrderId!: string;
    requestType!: ExpertChangeRequestType;
    status!: ExpertChangeRequestStatus;
    approvalStep?: ExpertChangeRequestApprovalStep;
    changeRequestTitle!: string;
    fullName!: string;
    position!: string;
    placeOfWork!: string;
    newExpertStatus?: string | undefined;
    attestationSubCommissionId!: string;
    attestationSubCommissionName!: string;
    approvals!: string[];

    constructor(data?: IExpertChangeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.approvals = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.dateTime = _data["dateTime"] ? moment(_data["dateTime"].toString()) : <any>undefined;
            this.expertId = _data["expertId"];
            this.expertChangeRequestsOrderId = _data["expertChangeRequestsOrderId"];
            this.requestType = _data["requestType"];
            this.status = _data["status"];
            this.approvalStep = _data["approvalStep"];
            this.changeRequestTitle = _data["changeRequestTitle"];
            this.fullName = _data["fullName"];
            this.position = _data["position"];
            this.placeOfWork = _data["placeOfWork"];
            this.newExpertStatus = _data["newExpertStatus"];
            this.attestationSubCommissionId = _data["attestationSubCommissionId"];
            this.attestationSubCommissionName = _data["attestationSubCommissionName"];
            if (Array.isArray(_data["approvals"])) {
                this.approvals = [] as any;
                for (let item of _data["approvals"])
                    this.approvals!.push(item);
            }
        }
    }

    static fromJS(data: any): ExpertChangeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ExpertChangeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["dateTime"] = this.dateTime ? this.dateTime.toISOString() : <any>undefined;
        data["expertId"] = this.expertId;
        data["expertChangeRequestsOrderId"] = this.expertChangeRequestsOrderId;
        data["requestType"] = this.requestType;
        data["status"] = this.status;
        data["approvalStep"] = this.approvalStep;
        data["changeRequestTitle"] = this.changeRequestTitle;
        data["fullName"] = this.fullName;
        data["position"] = this.position;
        data["placeOfWork"] = this.placeOfWork;
        data["newExpertStatus"] = this.newExpertStatus;
        data["attestationSubCommissionId"] = this.attestationSubCommissionId;
        data["attestationSubCommissionName"] = this.attestationSubCommissionName;
        if (Array.isArray(this.approvals)) {
            data["approvals"] = [];
            for (let item of this.approvals)
                data["approvals"].push(item);
        }
        return data; 
    }
}

export interface IExpertChangeRequest {
    id: string;
    dateTime: moment.Moment;
    expertId: string;
    expertChangeRequestsOrderId: string;
    requestType: ExpertChangeRequestType;
    status: ExpertChangeRequestStatus;
    approvalStep?: ExpertChangeRequestApprovalStep;
    changeRequestTitle: string;
    fullName: string;
    position: string;
    placeOfWork: string;
    newExpertStatus?: string | undefined;
    attestationSubCommissionId: string;
    attestationSubCommissionName: string;
    approvals: string[];
}

export enum ExpertChangeRequestApprovalStep {
    ApprovalByAscChairman = "approvalByAscChairman",
    ApprovalByAcSecretary = "approvalByAcSecretary",
    ApprovalByAcChairman = "approvalByAcChairman",
}

export class ExpertChangeRequestDetails implements IExpertChangeRequestDetails {
    id!: string;
    dateTime!: moment.Moment;
    expertId!: string;
    expertChangeRequestsOrderId!: string;
    requestType!: ExpertChangeRequestType;
    status!: ExpertChangeRequestStatus;
    approvalStep?: ExpertChangeRequestApprovalStep;
    changeRequestTitle!: string;
    fullName!: string;
    position!: string;
    placeOfWork!: string;
    newExpertStatus?: string | undefined;
    attestationSubCommissionId!: string;
    attestationSubCommissionName!: string;
    approvals!: string[];
    expert!: Expert;
    approvalProgress!: ApprovalProcessStep[];
    rejectReason?: string | undefined;

    constructor(data?: IExpertChangeRequestDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.approvals = [];
            this.expert = new Expert();
            this.approvalProgress = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.dateTime = _data["dateTime"] ? moment(_data["dateTime"].toString()) : <any>undefined;
            this.expertId = _data["expertId"];
            this.expertChangeRequestsOrderId = _data["expertChangeRequestsOrderId"];
            this.requestType = _data["requestType"];
            this.status = _data["status"];
            this.approvalStep = _data["approvalStep"];
            this.changeRequestTitle = _data["changeRequestTitle"];
            this.fullName = _data["fullName"];
            this.position = _data["position"];
            this.placeOfWork = _data["placeOfWork"];
            this.newExpertStatus = _data["newExpertStatus"];
            this.attestationSubCommissionId = _data["attestationSubCommissionId"];
            this.attestationSubCommissionName = _data["attestationSubCommissionName"];
            if (Array.isArray(_data["approvals"])) {
                this.approvals = [] as any;
                for (let item of _data["approvals"])
                    this.approvals!.push(item);
            }
            this.expert = _data["expert"] ? Expert.fromJS(_data["expert"]) : new Expert();
            if (Array.isArray(_data["approvalProgress"])) {
                this.approvalProgress = [] as any;
                for (let item of _data["approvalProgress"])
                    this.approvalProgress!.push(ApprovalProcessStep.fromJS(item));
            }
            this.rejectReason = _data["rejectReason"];
        }
    }

    static fromJS(data: any): ExpertChangeRequestDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ExpertChangeRequestDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["dateTime"] = this.dateTime ? this.dateTime.toISOString() : <any>undefined;
        data["expertId"] = this.expertId;
        data["expertChangeRequestsOrderId"] = this.expertChangeRequestsOrderId;
        data["requestType"] = this.requestType;
        data["status"] = this.status;
        data["approvalStep"] = this.approvalStep;
        data["changeRequestTitle"] = this.changeRequestTitle;
        data["fullName"] = this.fullName;
        data["position"] = this.position;
        data["placeOfWork"] = this.placeOfWork;
        data["newExpertStatus"] = this.newExpertStatus;
        data["attestationSubCommissionId"] = this.attestationSubCommissionId;
        data["attestationSubCommissionName"] = this.attestationSubCommissionName;
        if (Array.isArray(this.approvals)) {
            data["approvals"] = [];
            for (let item of this.approvals)
                data["approvals"].push(item);
        }
        data["expert"] = this.expert ? this.expert.toJSON() : <any>undefined;
        if (Array.isArray(this.approvalProgress)) {
            data["approvalProgress"] = [];
            for (let item of this.approvalProgress)
                data["approvalProgress"].push(item.toJSON());
        }
        data["rejectReason"] = this.rejectReason;
        return data; 
    }
}

export interface IExpertChangeRequestDetails {
    id: string;
    dateTime: moment.Moment;
    expertId: string;
    expertChangeRequestsOrderId: string;
    requestType: ExpertChangeRequestType;
    status: ExpertChangeRequestStatus;
    approvalStep?: ExpertChangeRequestApprovalStep;
    changeRequestTitle: string;
    fullName: string;
    position: string;
    placeOfWork: string;
    newExpertStatus?: string | undefined;
    attestationSubCommissionId: string;
    attestationSubCommissionName: string;
    approvals: string[];
    expert: Expert;
    approvalProgress: ApprovalProcessStep[];
    rejectReason?: string | undefined;
}

export class ExpertChangeRequests implements IExpertChangeRequests {
    items!: ExpertChangeRequest[];
    page!: number;
    pageSize!: number;
    total!: number;

    constructor(data?: IExpertChangeRequests) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ExpertChangeRequest.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.total = _data["total"];
        }
    }

    static fromJS(data: any): ExpertChangeRequests {
        data = typeof data === 'object' ? data : {};
        let result = new ExpertChangeRequests();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["total"] = this.total;
        return data; 
    }
}

export interface IExpertChangeRequests {
    items: ExpertChangeRequest[];
    page: number;
    pageSize: number;
    total: number;
}

export enum ExpertChangeRequestsOrderType {
    InterimCommissionsChanges = "interimCommissionsChanges",
    NewCommissionsFormationProcedure = "newCommissionsFormationProcedure",
}

export enum ExpertChangeRequestStatus {
    Approving = "approving",
    Approved = "approved",
    Rejected = "rejected",
}

export enum ExpertChangeRequestType {
    IncludeInAsc = "includeInAsc",
    ExcludeFromAsc = "excludeFromAsc",
    UpdateAscStatus = "updateAscStatus",
    UpdateFullName = "updateFullName",
    UpdatePosition = "updatePosition",
}

export class ExpertConfirmationData implements IExpertConfirmationData {
    firstName!: string;
    lastName!: string;
    middleName!: string;
    phone!: string;
    email!: string;

    constructor(data?: IExpertConfirmationData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.middleName = _data["middleName"];
            this.phone = _data["phone"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): ExpertConfirmationData {
        data = typeof data === 'object' ? data : {};
        let result = new ExpertConfirmationData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["middleName"] = this.middleName;
        data["phone"] = this.phone;
        data["email"] = this.email;
        return data; 
    }
}

export interface IExpertConfirmationData {
    firstName: string;
    lastName: string;
    middleName: string;
    phone: string;
    email: string;
}

export class ExpertDetails implements IExpertDetails {
    id!: string;
    firstName!: string;
    lastName!: string;
    middleName!: string;
    birthDate!: moment.Moment;
    sex!: Sex;
    phone!: string;
    email!: string;
    regionId!: number;
    region!: string;
    readonly timeZoneOffset!: number;
    linkedExpertStatuses!: LinkedExpertStatus[];
    emailConfirmed!: boolean;
    registrationCompleted!: boolean;
    position!: string;
    /** Место работы */
    placeOfWork!: string;
    /** СНИЛС */
    snils!: string;
    /** ИД должности */
    positionId?: number | undefined;
    /** Другое название должности */
    otherPositionTitle?: string | undefined;
    /** Членство */
    membership?: string | undefined;
    placeOfWorkDetails?: OrganizationInfo;
    qualifications!: ExpertQualification[];
    linkedExpertStatusesDetails!: LinkedExpertStatusDetails[];

    constructor(data?: IExpertDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.linkedExpertStatuses = [];
            this.qualifications = [];
            this.linkedExpertStatusesDetails = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.middleName = _data["middleName"];
            this.birthDate = _data["birthDate"] ? moment(_data["birthDate"].toString()) : <any>undefined;
            this.sex = _data["sex"];
            this.phone = _data["phone"];
            this.email = _data["email"];
            this.regionId = _data["regionId"];
            this.region = _data["region"];
            (<any>this).timeZoneOffset = _data["timeZoneOffset"];
            if (Array.isArray(_data["linkedExpertStatuses"])) {
                this.linkedExpertStatuses = [] as any;
                for (let item of _data["linkedExpertStatuses"])
                    this.linkedExpertStatuses!.push(LinkedExpertStatus.fromJS(item));
            }
            this.emailConfirmed = _data["emailConfirmed"];
            this.registrationCompleted = _data["registrationCompleted"];
            this.position = _data["position"];
            this.placeOfWork = _data["placeOfWork"];
            this.snils = _data["snils"];
            this.positionId = _data["positionId"];
            this.otherPositionTitle = _data["otherPositionTitle"];
            this.membership = _data["membership"];
            this.placeOfWorkDetails = _data["placeOfWorkDetails"] ? OrganizationInfo.fromJS(_data["placeOfWorkDetails"]) : <any>undefined;
            if (Array.isArray(_data["qualifications"])) {
                this.qualifications = [] as any;
                for (let item of _data["qualifications"])
                    this.qualifications!.push(ExpertQualification.fromJS(item));
            }
            if (Array.isArray(_data["linkedExpertStatusesDetails"])) {
                this.linkedExpertStatusesDetails = [] as any;
                for (let item of _data["linkedExpertStatusesDetails"])
                    this.linkedExpertStatusesDetails!.push(LinkedExpertStatusDetails.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ExpertDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ExpertDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["middleName"] = this.middleName;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["sex"] = this.sex;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["regionId"] = this.regionId;
        data["region"] = this.region;
        data["timeZoneOffset"] = this.timeZoneOffset;
        if (Array.isArray(this.linkedExpertStatuses)) {
            data["linkedExpertStatuses"] = [];
            for (let item of this.linkedExpertStatuses)
                data["linkedExpertStatuses"].push(item.toJSON());
        }
        data["emailConfirmed"] = this.emailConfirmed;
        data["registrationCompleted"] = this.registrationCompleted;
        data["position"] = this.position;
        data["placeOfWork"] = this.placeOfWork;
        data["snils"] = this.snils;
        data["positionId"] = this.positionId;
        data["otherPositionTitle"] = this.otherPositionTitle;
        data["membership"] = this.membership;
        data["placeOfWorkDetails"] = this.placeOfWorkDetails ? this.placeOfWorkDetails.toJSON() : <any>undefined;
        if (Array.isArray(this.qualifications)) {
            data["qualifications"] = [];
            for (let item of this.qualifications)
                data["qualifications"].push(item.toJSON());
        }
        if (Array.isArray(this.linkedExpertStatusesDetails)) {
            data["linkedExpertStatusesDetails"] = [];
            for (let item of this.linkedExpertStatusesDetails)
                data["linkedExpertStatusesDetails"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IExpertDetails {
    id: string;
    firstName: string;
    lastName: string;
    middleName: string;
    birthDate: moment.Moment;
    sex: Sex;
    phone: string;
    email: string;
    regionId: number;
    region: string;
    timeZoneOffset: number;
    linkedExpertStatuses: LinkedExpertStatus[];
    emailConfirmed: boolean;
    registrationCompleted: boolean;
    position: string;
    /** Место работы */
    placeOfWork: string;
    /** СНИЛС */
    snils: string;
    /** ИД должности */
    positionId?: number | undefined;
    /** Другое название должности */
    otherPositionTitle?: string | undefined;
    /** Членство */
    membership?: string | undefined;
    placeOfWorkDetails?: OrganizationInfo;
    qualifications: ExpertQualification[];
    linkedExpertStatusesDetails: LinkedExpertStatusDetails[];
}

export class ExpertQualification implements IExpertQualification {
    id!: string;
    regNumber!: string;
    title!: string;
    /** Дата начала стажа работы */
    experienceStartDate!: moment.Moment;

    constructor(data?: IExpertQualification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.regNumber = _data["regNumber"];
            this.title = _data["title"];
            this.experienceStartDate = _data["experienceStartDate"] ? moment(_data["experienceStartDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ExpertQualification {
        data = typeof data === 'object' ? data : {};
        let result = new ExpertQualification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["regNumber"] = this.regNumber;
        data["title"] = this.title;
        data["experienceStartDate"] = this.experienceStartDate ? this.experienceStartDate.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IExpertQualification {
    id: string;
    regNumber: string;
    title: string;
    /** Дата начала стажа работы */
    experienceStartDate: moment.Moment;
}

export class Experts implements IExperts {
    items!: Expert[];
    page!: number;
    pageSize!: number;
    total!: number;

    constructor(data?: IExperts) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(Expert.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.total = _data["total"];
        }
    }

    static fromJS(data: any): Experts {
        data = typeof data === 'object' ? data : {};
        let result = new Experts();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["total"] = this.total;
        return data; 
    }
}

export interface IExperts {
    items: Expert[];
    page: number;
    pageSize: number;
    total: number;
}

export enum ExpertStatus {
    AscMember = "ascMember",
    AscSecretary = "ascSecretary",
    AscChairman = "ascChairman",
    AscViceChairman = "ascViceChairman",
    AcSecretary = "acSecretary",
    AcChairman = "acChairman",
    AcViceChairman = "acViceChairman",
}

export enum FilteredExamStatus {
    AwaitingExpertConfirmation = "awaitingExpertConfirmation",
    IsApplying = "isApplying",
    ApplyingFinished = "applyingFinished",
    Staging = "staging",
    Finished = "finished",
    Canceled = "canceled",
}

export enum FinalizedResult {
    None = "none",
    Passed = "passed",
    NotPassed = "notPassed",
    Absent = "absent",
}

export enum IdentityDocType {
    Passport = "passport",
    Residence = "residence",
    MilitaryTicket = "militaryTicket",
    TemporaryIdentity = "temporaryIdentity",
    DiplomaticPassport = "diplomaticPassport",
    StatelessPersonIdentity = "statelessPersonIdentity",
    InternationalPassport = "internationalPassport",
    ForeignCitizenPassport = "foreignCitizenPassport",
    TemporaryResidencePermit = "temporaryResidencePermit",
    ServicePassport = "servicePassport",
    RefugeeIdentity = "refugeeIdentity",
    ServicemanIdentity = "servicemanIdentity",
    SeafarerIdentity = "seafarerIdentity",
}

export class LinkedExpert implements ILinkedExpert {
    id!: string;
    firstName!: string;
    lastName!: string;
    middleName!: string;
    birthDate!: moment.Moment;
    sex!: Sex;
    phone!: string;
    email!: string;
    regionId!: number;
    region!: string;
    readonly timeZoneOffset!: number;
    linkedExpertStatuses!: LinkedExpertStatus[];
    emailConfirmed!: boolean;
    registrationCompleted!: boolean;
    position!: string;
    /** Место работы */
    placeOfWork!: string;
    /** СНИЛС */
    snils!: string;
    /** ИД должности */
    positionId?: number | undefined;
    /** Другое название должности */
    otherPositionTitle?: string | undefined;
    /** Членство */
    membership?: string | undefined;
    placeOfWorkDetails?: OrganizationInfo;
    qualifications!: ExpertQualification[];
    linkedExpertStatusesDetails!: LinkedExpertStatusDetails[];
    status!: ExpertStatus;
    readonly attestationCommissionId!: string;
    readonly attestationSubCommissionId?: string | undefined;
    readonly qualificationId?: string | undefined;
    readonly attestationCommissionName!: string;
    readonly attestationSubCommissionName?: string | undefined;

    constructor(data?: ILinkedExpert) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.linkedExpertStatuses = [];
            this.qualifications = [];
            this.linkedExpertStatusesDetails = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.middleName = _data["middleName"];
            this.birthDate = _data["birthDate"] ? moment(_data["birthDate"].toString()) : <any>undefined;
            this.sex = _data["sex"];
            this.phone = _data["phone"];
            this.email = _data["email"];
            this.regionId = _data["regionId"];
            this.region = _data["region"];
            (<any>this).timeZoneOffset = _data["timeZoneOffset"];
            if (Array.isArray(_data["linkedExpertStatuses"])) {
                this.linkedExpertStatuses = [] as any;
                for (let item of _data["linkedExpertStatuses"])
                    this.linkedExpertStatuses!.push(LinkedExpertStatus.fromJS(item));
            }
            this.emailConfirmed = _data["emailConfirmed"];
            this.registrationCompleted = _data["registrationCompleted"];
            this.position = _data["position"];
            this.placeOfWork = _data["placeOfWork"];
            this.snils = _data["snils"];
            this.positionId = _data["positionId"];
            this.otherPositionTitle = _data["otherPositionTitle"];
            this.membership = _data["membership"];
            this.placeOfWorkDetails = _data["placeOfWorkDetails"] ? OrganizationInfo.fromJS(_data["placeOfWorkDetails"]) : <any>undefined;
            if (Array.isArray(_data["qualifications"])) {
                this.qualifications = [] as any;
                for (let item of _data["qualifications"])
                    this.qualifications!.push(ExpertQualification.fromJS(item));
            }
            if (Array.isArray(_data["linkedExpertStatusesDetails"])) {
                this.linkedExpertStatusesDetails = [] as any;
                for (let item of _data["linkedExpertStatusesDetails"])
                    this.linkedExpertStatusesDetails!.push(LinkedExpertStatusDetails.fromJS(item));
            }
            this.status = _data["status"];
            (<any>this).attestationCommissionId = _data["attestationCommissionId"];
            (<any>this).attestationSubCommissionId = _data["attestationSubCommissionId"];
            (<any>this).qualificationId = _data["qualificationId"];
            (<any>this).attestationCommissionName = _data["attestationCommissionName"];
            (<any>this).attestationSubCommissionName = _data["attestationSubCommissionName"];
        }
    }

    static fromJS(data: any): LinkedExpert {
        data = typeof data === 'object' ? data : {};
        let result = new LinkedExpert();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["middleName"] = this.middleName;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["sex"] = this.sex;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["regionId"] = this.regionId;
        data["region"] = this.region;
        data["timeZoneOffset"] = this.timeZoneOffset;
        if (Array.isArray(this.linkedExpertStatuses)) {
            data["linkedExpertStatuses"] = [];
            for (let item of this.linkedExpertStatuses)
                data["linkedExpertStatuses"].push(item.toJSON());
        }
        data["emailConfirmed"] = this.emailConfirmed;
        data["registrationCompleted"] = this.registrationCompleted;
        data["position"] = this.position;
        data["placeOfWork"] = this.placeOfWork;
        data["snils"] = this.snils;
        data["positionId"] = this.positionId;
        data["otherPositionTitle"] = this.otherPositionTitle;
        data["membership"] = this.membership;
        data["placeOfWorkDetails"] = this.placeOfWorkDetails ? this.placeOfWorkDetails.toJSON() : <any>undefined;
        if (Array.isArray(this.qualifications)) {
            data["qualifications"] = [];
            for (let item of this.qualifications)
                data["qualifications"].push(item.toJSON());
        }
        if (Array.isArray(this.linkedExpertStatusesDetails)) {
            data["linkedExpertStatusesDetails"] = [];
            for (let item of this.linkedExpertStatusesDetails)
                data["linkedExpertStatusesDetails"].push(item.toJSON());
        }
        data["status"] = this.status;
        data["attestationCommissionId"] = this.attestationCommissionId;
        data["attestationSubCommissionId"] = this.attestationSubCommissionId;
        data["qualificationId"] = this.qualificationId;
        data["attestationCommissionName"] = this.attestationCommissionName;
        data["attestationSubCommissionName"] = this.attestationSubCommissionName;
        return data; 
    }
}

export interface ILinkedExpert {
    id: string;
    firstName: string;
    lastName: string;
    middleName: string;
    birthDate: moment.Moment;
    sex: Sex;
    phone: string;
    email: string;
    regionId: number;
    region: string;
    timeZoneOffset: number;
    linkedExpertStatuses: LinkedExpertStatus[];
    emailConfirmed: boolean;
    registrationCompleted: boolean;
    position: string;
    /** Место работы */
    placeOfWork: string;
    /** СНИЛС */
    snils: string;
    /** ИД должности */
    positionId?: number | undefined;
    /** Другое название должности */
    otherPositionTitle?: string | undefined;
    /** Членство */
    membership?: string | undefined;
    placeOfWorkDetails?: OrganizationInfo;
    qualifications: ExpertQualification[];
    linkedExpertStatusesDetails: LinkedExpertStatusDetails[];
    status: ExpertStatus;
    attestationCommissionId: string;
    attestationSubCommissionId?: string | undefined;
    qualificationId?: string | undefined;
    attestationCommissionName: string;
    attestationSubCommissionName?: string | undefined;
}

export class LinkedExpertStatus implements ILinkedExpertStatus {
    acId!: string;
    ascId?: string | undefined;
    status!: ExpertStatus;

    constructor(data?: ILinkedExpertStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.acId = _data["acId"];
            this.ascId = _data["ascId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): LinkedExpertStatus {
        data = typeof data === 'object' ? data : {};
        let result = new LinkedExpertStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["acId"] = this.acId;
        data["ascId"] = this.ascId;
        data["status"] = this.status;
        return data; 
    }
}

export interface ILinkedExpertStatus {
    acId: string;
    ascId?: string | undefined;
    status: ExpertStatus;
}

export class LinkedExpertStatusDetails implements ILinkedExpertStatusDetails {
    acId!: string;
    ascId?: string | undefined;
    status!: ExpertStatus;
    regionName!: string;
    qualificationTitle?: string | undefined;

    constructor(data?: ILinkedExpertStatusDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.acId = _data["acId"];
            this.ascId = _data["ascId"];
            this.status = _data["status"];
            this.regionName = _data["regionName"];
            this.qualificationTitle = _data["qualificationTitle"];
        }
    }

    static fromJS(data: any): LinkedExpertStatusDetails {
        data = typeof data === 'object' ? data : {};
        let result = new LinkedExpertStatusDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["acId"] = this.acId;
        data["ascId"] = this.ascId;
        data["status"] = this.status;
        data["regionName"] = this.regionName;
        data["qualificationTitle"] = this.qualificationTitle;
        return data; 
    }
}

export interface ILinkedExpertStatusDetails {
    acId: string;
    ascId?: string | undefined;
    status: ExpertStatus;
    regionName: string;
    qualificationTitle?: string | undefined;
}

export class LoginExpert implements ILoginExpert {
    captcha?: string | undefined;
    phone!: string;
    password!: string;

    constructor(data?: ILoginExpert) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.captcha = _data["captcha"];
            this.phone = _data["phone"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): LoginExpert {
        data = typeof data === 'object' ? data : {};
        let result = new LoginExpert();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["captcha"] = this.captcha;
        data["phone"] = this.phone;
        data["password"] = this.password;
        return data; 
    }
}

export interface ILoginExpert {
    captcha?: string | undefined;
    phone: string;
    password: string;
}

/** Отношение к воинской службе */
export enum MilitaryRelationshipType {
    Reservist = "reservist",
    Serviceman = "serviceman",
    NonLiable = "nonLiable",
    Conscript = "conscript",
    CustomsOfficer = "customsOfficer",
}

export class OrganizationInfo implements IOrganizationInfo {
    name!: string;
    inn!: string;
    ogrn!: string;
    region!: string;
    city!: string;
    address!: string;

    constructor(data?: IOrganizationInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.inn = _data["inn"];
            this.ogrn = _data["ogrn"];
            this.region = _data["region"];
            this.city = _data["city"];
            this.address = _data["address"];
        }
    }

    static fromJS(data: any): OrganizationInfo {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["inn"] = this.inn;
        data["ogrn"] = this.ogrn;
        data["region"] = this.region;
        data["city"] = this.city;
        data["address"] = this.address;
        return data; 
    }
}

export interface IOrganizationInfo {
    name: string;
    inn: string;
    ogrn: string;
    region: string;
    city: string;
    address: string;
}

export class QualificationInfo implements IQualificationInfo {
    id!: string;
    title!: string;
    stagesNumber!: number;
    regNumber!: string;
    occupationalStandardId!: string;
    occupationalStandardTitle!: string;
    readyToUse!: boolean;
    residency!: boolean;

    constructor(data?: IQualificationInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.stagesNumber = _data["stagesNumber"];
            this.regNumber = _data["regNumber"];
            this.occupationalStandardId = _data["occupationalStandardId"];
            this.occupationalStandardTitle = _data["occupationalStandardTitle"];
            this.readyToUse = _data["readyToUse"];
            this.residency = _data["residency"];
        }
    }

    static fromJS(data: any): QualificationInfo {
        data = typeof data === 'object' ? data : {};
        let result = new QualificationInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["stagesNumber"] = this.stagesNumber;
        data["regNumber"] = this.regNumber;
        data["occupationalStandardId"] = this.occupationalStandardId;
        data["occupationalStandardTitle"] = this.occupationalStandardTitle;
        data["readyToUse"] = this.readyToUse;
        data["residency"] = this.residency;
        return data; 
    }
}

export interface IQualificationInfo {
    id: string;
    title: string;
    stagesNumber: number;
    regNumber: string;
    occupationalStandardId: string;
    occupationalStandardTitle: string;
    readyToUse: boolean;
    residency: boolean;
}

export class QualificationInfoList implements IQualificationInfoList {
    items!: QualificationInfo[];
    page!: number;
    pageSize!: number;
    total!: number;

    constructor(data?: IQualificationInfoList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(QualificationInfo.fromJS(item));
            }
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
            this.total = _data["total"];
        }
    }

    static fromJS(data: any): QualificationInfoList {
        data = typeof data === 'object' ? data : {};
        let result = new QualificationInfoList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        data["total"] = this.total;
        return data; 
    }
}

export interface IQualificationInfoList {
    items: QualificationInfo[];
    page: number;
    pageSize: number;
    total: number;
}

export class RejectExpertChangeRequest implements IRejectExpertChangeRequest {
    captcha?: string | undefined;
    code!: string;
    rejectReason!: string;

    constructor(data?: IRejectExpertChangeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.captcha = _data["captcha"];
            this.code = _data["code"];
            this.rejectReason = _data["rejectReason"];
        }
    }

    static fromJS(data: any): RejectExpertChangeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RejectExpertChangeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["captcha"] = this.captcha;
        data["code"] = this.code;
        data["rejectReason"] = this.rejectReason;
        return data; 
    }
}

export interface IRejectExpertChangeRequest {
    captcha?: string | undefined;
    code: string;
    rejectReason: string;
}

export class ResetPassword implements IResetPassword {
    captcha?: string | undefined;
    /** Код верификации */
    verificationCode!: string;
    /** Номер телефона аккредитуемого */
    phone!: string;
    /** Новый пароль */
    newPassword!: string;

    constructor(data?: IResetPassword) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.captcha = _data["captcha"];
            this.verificationCode = _data["verificationCode"];
            this.phone = _data["phone"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ResetPassword {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPassword();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["captcha"] = this.captcha;
        data["verificationCode"] = this.verificationCode;
        data["phone"] = this.phone;
        data["newPassword"] = this.newPassword;
        return data; 
    }
}

export interface IResetPassword {
    captcha?: string | undefined;
    /** Код верификации */
    verificationCode: string;
    /** Номер телефона аккредитуемого */
    phone: string;
    /** Новый пароль */
    newPassword: string;
}

export class SendCodeForApproveExam implements ISendCodeForApproveExam {
    captcha?: string | undefined;

    constructor(data?: ISendCodeForApproveExam) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.captcha = _data["captcha"];
        }
    }

    static fromJS(data: any): SendCodeForApproveExam {
        data = typeof data === 'object' ? data : {};
        let result = new SendCodeForApproveExam();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["captcha"] = this.captcha;
        return data; 
    }
}

export interface ISendCodeForApproveExam {
    captcha?: string | undefined;
}

export class SendCodeForApproveExpertChangeRequest implements ISendCodeForApproveExpertChangeRequest {
    captcha?: string | undefined;

    constructor(data?: ISendCodeForApproveExpertChangeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.captcha = _data["captcha"];
        }
    }

    static fromJS(data: any): SendCodeForApproveExpertChangeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SendCodeForApproveExpertChangeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["captcha"] = this.captcha;
        return data; 
    }
}

export interface ISendCodeForApproveExpertChangeRequest {
    captcha?: string | undefined;
}

export class SendConfirmationEmailAgain implements ISendConfirmationEmailAgain {
    captcha?: string | undefined;

    constructor(data?: ISendConfirmationEmailAgain) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.captcha = _data["captcha"];
        }
    }

    static fromJS(data: any): SendConfirmationEmailAgain {
        data = typeof data === 'object' ? data : {};
        let result = new SendConfirmationEmailAgain();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["captcha"] = this.captcha;
        return data; 
    }
}

export interface ISendConfirmationEmailAgain {
    captcha?: string | undefined;
}

export class SendVerificationCode implements ISendVerificationCode {
    captcha?: string | undefined;
    phone!: string;

    constructor(data?: ISendVerificationCode) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.captcha = _data["captcha"];
            this.phone = _data["phone"];
        }
    }

    static fromJS(data: any): SendVerificationCode {
        data = typeof data === 'object' ? data : {};
        let result = new SendVerificationCode();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["captcha"] = this.captcha;
        data["phone"] = this.phone;
        return data; 
    }
}

export interface ISendVerificationCode {
    captcha?: string | undefined;
    phone: string;
}

export class SendVerificationCodeForUpdatePhone implements ISendVerificationCodeForUpdatePhone {
    captcha?: string | undefined;
    phone!: string;
    /** Пароль */
    password!: string;

    constructor(data?: ISendVerificationCodeForUpdatePhone) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.captcha = _data["captcha"];
            this.phone = _data["phone"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): SendVerificationCodeForUpdatePhone {
        data = typeof data === 'object' ? data : {};
        let result = new SendVerificationCodeForUpdatePhone();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["captcha"] = this.captcha;
        data["phone"] = this.phone;
        data["password"] = this.password;
        return data; 
    }
}

export interface ISendVerificationCodeForUpdatePhone {
    captcha?: string | undefined;
    phone: string;
    /** Пароль */
    password: string;
}

export enum Sex {
    Male = "male",
    Female = "female",
}

export class SourceFile implements ISourceFile {
    readonly fileId!: string;
    readonly fileExtension!: string;
    readonly fileSize!: number;
    readonly fileUrl!: string;
    fileName?: string | undefined;

    constructor(data?: ISourceFile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).fileId = _data["fileId"];
            (<any>this).fileExtension = _data["fileExtension"];
            (<any>this).fileSize = _data["fileSize"];
            (<any>this).fileUrl = _data["fileUrl"];
            this.fileName = _data["fileName"];
        }
    }

    static fromJS(data: any): SourceFile {
        data = typeof data === 'object' ? data : {};
        let result = new SourceFile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileId"] = this.fileId;
        data["fileExtension"] = this.fileExtension;
        data["fileSize"] = this.fileSize;
        data["fileUrl"] = this.fileUrl;
        data["fileName"] = this.fileName;
        return data; 
    }
}

export interface ISourceFile {
    fileId: string;
    fileExtension: string;
    fileSize: number;
    fileUrl: string;
    fileName?: string | undefined;
}

export class UpdateExpertQualification implements IUpdateExpertQualification {
    qualificationId!: string;
    /** Дата начала стажа работы */
    experienceStartDate!: moment.Moment;

    constructor(data?: IUpdateExpertQualification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.qualificationId = _data["qualificationId"];
            this.experienceStartDate = _data["experienceStartDate"] ? moment(_data["experienceStartDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateExpertQualification {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateExpertQualification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["qualificationId"] = this.qualificationId;
        data["experienceStartDate"] = this.experienceStartDate ? this.experienceStartDate.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IUpdateExpertQualification {
    qualificationId: string;
    /** Дата начала стажа работы */
    experienceStartDate: moment.Moment;
}

export class UpdatePhone implements IUpdatePhone {
    /** Номер телефона */
    phone!: string;
    /** Код верификации */
    verificationCode!: string;

    constructor(data?: IUpdatePhone) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.phone = _data["phone"];
            this.verificationCode = _data["verificationCode"];
        }
    }

    static fromJS(data: any): UpdatePhone {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePhone();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phone"] = this.phone;
        data["verificationCode"] = this.verificationCode;
        return data; 
    }
}

export interface IUpdatePhone {
    /** Номер телефона */
    phone: string;
    /** Код верификации */
    verificationCode: string;
}

export class UserAuthToken implements IUserAuthToken {
    name!: string;
    token!: string;

    constructor(data?: IUserAuthToken) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.token = _data["token"];
        }
    }

    static fromJS(data: any): UserAuthToken {
        data = typeof data === 'object' ? data : {};
        let result = new UserAuthToken();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["token"] = this.token;
        return data; 
    }
}

export interface IUserAuthToken {
    name: string;
    token: string;
}

export class VerificationCodeSendingStatus implements IVerificationCodeSendingStatus {
    /** Были ли отправлен новый код или надо подождать */
    wasSent?: boolean;
    /** Время ожидания отправки нового кода */
    waitingSeconds?: number;

    constructor(data?: IVerificationCodeSendingStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.wasSent = _data["wasSent"];
            this.waitingSeconds = _data["waitingSeconds"];
        }
    }

    static fromJS(data: any): VerificationCodeSendingStatus {
        data = typeof data === 'object' ? data : {};
        let result = new VerificationCodeSendingStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["wasSent"] = this.wasSent;
        data["waitingSeconds"] = this.waitingSeconds;
        return data; 
    }
}

export interface IVerificationCodeSendingStatus {
    /** Были ли отправлен новый код или надо подождать */
    wasSent?: boolean;
    /** Время ожидания отправки нового кода */
    waitingSeconds?: number;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

export class ApiClient extends ApiClientBase {
    private http2: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl2: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(baseUrl, http);
        this.http2 = http ? http : <any>window;
        this.baseUrl2 = baseUrl ? baseUrl : "";
    }

    addExpertCertificateFix(regNumber: string, issueDate: moment.Moment, expireDate: moment.Moment, file: File): Promise<ExpertCertificate[]> {
        let url_ = this.baseUrl2 + "/api/v1/certificates";

        const content_ = new FormData();

        if (regNumber === null || regNumber === undefined)
            throw new Error("The parameter ‘regNumber’ cannot be null.");
        else
            content_.append("regNumber", regNumber.toString());
            
        if (issueDate === null || issueDate === undefined)
            throw new Error("The parameter ‘issueDate’ cannot be null.");
        else
            content_.append("issueDate", issueDate.toISOString());
                    
        if (expireDate === null || expireDate === undefined)
            throw new Error("The parameter ‘expireDate’ cannot be null.");
        else
            content_.append("expireDate", expireDate.toISOString());
        
        if (file === null || file === undefined)
            throw new Error("The parameter ‘file’ cannot be null.");
        else
            content_.append("file", file, file.name ? file.name : "file");

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http2.fetch(url_, options_).then((_response: Response) => {
            return this.processAddExpertCertificate(_response);
        });
    }
    
    updateExpertCertificateFix(certificateId: string, regNumber: string, issueDate: moment.Moment, expireDate: moment.Moment, file: File | undefined): Promise<ExpertCertificate[]> {
        let url_ = this.baseUrl2 + "/api/v1/certificates/{certificateId}";
        if (certificateId === undefined || certificateId === null)
            throw new Error("The parameter 'certificateId' must be defined.");
        url_ = url_.replace("{certificateId}", encodeURIComponent("" + certificateId)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();

        if (regNumber === null || regNumber === undefined)
            throw new Error("The parameter ‘regNumber’ cannot be null.");
        else
            content_.append("regNumber", regNumber.toString());
            
        if (issueDate === null || issueDate === undefined)
            throw new Error("The parameter ‘issueDate’ cannot be null.");
        else
            content_.append("issueDate", issueDate.toISOString());
                    
        if (expireDate === null || expireDate === undefined)
            throw new Error("The parameter ‘expireDate’ cannot be null.");
        else
            content_.append("expireDate", expireDate.toISOString());
        
        if (file !== null && file !== undefined)
            content_.append("file", file, file.name ? file.name : "file");

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http2.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateExpertCertificate(_response);
        });
    }
}